<form #form="ngForm" novalidate class="cliente-analise-mercado-lancamento-form">
    <ng-template [ngIf]="isLoading">
        <p class="text-muted m-0">
            <i class='fas fa-spinner fa-pulse'></i> Carregando lançamento da Análise de Mercado
        </p>
    </ng-template>

    <ng-template [ngIf]="!isLoading && entityLancamento">
        <sgt-cliente-analise-mercado-header
            [idCliente]="entityLancamento.idCliente"
            [tipoPessoa]="entityLancamento.tipoPessoa"
            [codigoIntegracaoErpCliente]="entityLancamento.codigoIntegracaoErpCliente"
            [cnpjCpfCliente]="entityLancamento.cnpjCpfCliente"
            [nomeCliente]="entityLancamento.nomeCliente"
            [nomeFantasiaCliente]="entityLancamento.nomeFantasiaCliente"
            [showParticipantesCentralCompras]="false"
            [showRepresentante]="false"
            [showAno]="false">
        </sgt-cliente-analise-mercado-header>

        <div class="row" *ngIf="entityLancamento.classificacoesNome">
            <div class="form-group col-12">
                <label class="col-form-label">Segmento</label>
                <input type="text" class="form-control" [value]="entityLancamento.classificacoesNome" disabled="disabled" readonly="readonly">
            </div>
        </div>

        <table class="table table-striped table-hover table-bordered"
            [class.lancamento-quantidade]="isLancamentoQuantidade()"
            [class.lancamento-peso]="isLancamentoPeso()"
            [class.lancamento-valor]="isLancamentoValor()"
            [class.classificacao-rap]="config?.isPerspectivaRAP">
            <thead>
                <!-- Agrupamento por Lançamento -->
                <tr class="row-lancamento">
                    <th class="col-periodicidade" rowspan="3" (click)="toggleTrimestres()">
                        <i class="fas fa-plus" *ngIf="entityLancamento.trimestresCollapsesShow"></i>
                        <i class="fas fa-minus" *ngIf="!entityLancamento.trimestresCollapsesShow"></i>
                        Periodicidade
                    </th>

                    <!-- <th class="col-status text-center" colspan="2" rowspan="2">Status</th> -->

                    <!-- Quantidade -->
                    <!-- <ng-template [ngIf]="entityLancamento.controleQuantidade">
                        <th class="col-lancamento col-quantidade col-separator text-center" [attr.colspan]="tableColspanQuantidade">
                            <div class="custom-control custom-radio custom-control-inline">
                                <input type="radio" class="custom-control-input" name="lancamento" id="lancamentoQuantidade"
                                    [value]="lancamentoQuantidade.id" [(ngModel)]="entityLancamento.lancamento" (ngModelChange)="onSelectLancamento()"
                                    required="required" disabled="disabled" readonly="readonly">
                                <label class="custom-control-label" for="lancamentoQuantidade">{{lancamentoQuantidade.nome}}</label>
                            </div>
                        </th>
                    </ng-template> -->

                    <!-- Peso -->
                    <!-- <ng-template [ngIf]="entityLancamento.controlePeso">
                        <th class="col-lancamento col-peso col-separator text-center" [attr.colspan]="tableColspanPeso">
                            <div class="custom-control custom-radio custom-control-inline">
                                <input type="radio" class="custom-control-input" name="lancamento" id="lancamentoPeso"
                                    [value]="lancamentoPeso.id" [(ngModel)]="entityLancamento.lancamento" (ngModelChange)="onSelectLancamento()"
                                    required="required" disabled="disabled" readonly="readonly">
                                <label class="custom-control-label" for="lancamentoPeso">{{lancamentoPeso.nome}}</label>
                            </div>
                        </th>
                    </ng-template>                             -->

                    <!-- Valor -->
                    <!-- <ng-template [ngIf]="entityLancamento.controleValor">
                        <th class="col-lancamento col-valor text-center" [attr.colspan]="tableColspanValor">
                            <div class="custom-control custom-radio custom-control-inline">
                                <input type="radio" class="custom-control-input" name="lancamento" id="lancamentoValor"
                                    [value]="lancamentoValor.id" [(ngModel)]="entityLancamento.lancamento" (ngModelChange)="onSelectLancamento()"
                                    required="required" disabled="disabled" readonly="readonly">
                                <label class="custom-control-label" for="lancamentoValor">{{lancamentoValor.nome}}</label>
                            </div>
                        </th>
                    </ng-template> -->
                </tr>

                <!-- Agrupamento por Ano -->
                <tr class="row-ano">
                    <!-- Quantidade-->
                    <ng-template [ngIf]="entityLancamento.controleQuantidade">
                        <!-- Ano Anterior 2 -->
                        <th class="col-quantidade col-ano-anterior2 col-separator text-center">
                            {{entityLancamento.anoAnterior2}}
                        </th>
                        <!-- Ano Anterior 1 -->
                        <th class="col-quantidade col-ano-anterior1 col-separator text-center" [attr.colspan]="tableColspanQuantidadeAnoAnterior1">
                            {{entityLancamento.anoAnterior1}}
                        </th>
                        <!-- Ano -->
                        <th class="col-quantidade col-ano col-separator text-center" [attr.colspan]="tableColspanQuantidadeAno">
                            {{entityLancamento.ano}}
                        </th>
                    </ng-template>

                    <!-- Peso-->
                    <ng-template [ngIf]="entityLancamento.controlePeso">
                        <!-- Ano Anterior 2 -->
                        <th class="col-peso col-ano-anterior2 col-separator text-center">
                            {{entityLancamento.anoAnterior2}}
                        </th>
                        <!-- Ano Anterior 1 -->
                        <th class="col-peso col-ano-anterior1 col-separator text-center" [attr.colspan]="tableColspanPesoAnoAnterior1">
                            {{entityLancamento.anoAnterior1}}
                        </th>
                        <!-- Ano -->
                        <th class="col-peso col-ano col-separator col-separator text-center" [attr.colspan]="tableColspanPesoAno">
                            {{entityLancamento.ano}}
                        </th>
                    </ng-template>

                    <!-- Valor -->
                    <ng-template [ngIf]="entityLancamento.controleValor">
                        <!-- Ano Anterior 2 -->
                        <th class="col-valor col-ano-anterior2 col-valor-realizado col-separator text-center">
                            {{entityLancamento.anoAnterior2}}
                        </th>

                        <!-- Ano Anterior 1 -->
                        <th class="col-valor col-ano-anterior1 col-valor-realizado col-separator text-center" colspan=2>
                            {{entityLancamento.anoAnterior1}}
                        </th>

                        <th class="col-valor col-ano col-valor-potencial col-separator text-right" rowspan="2" *ngIf="configAnaliseMercado?.solicitarPotencial && isLancamentoValor()">
                            Sell In Cliente
                        </th>

                        <!-- CS RAP -->
                        <th class="col-separator text-center" colspan="3" [title]="KPI_CUSTOMER_SHARE.nome">
                            {{KPI_CUSTOMER_SHARE.nome}} RAP
                        </th>

                        <!-- CS RAR -->
                        <th class="text-center" colspan="2" [title]="KPI_CUSTOMER_SHARE.nome">
                            {{KPI_CUSTOMER_SHARE.nome}} RAR
                        </th>
                    </ng-template>
                </tr>

                <!-- Valores -->
                <tr class="row-valores">
                    <!--
                    <th class="col-status col-status-pretendido text-center">Pretendido</th>
                    <th class="col-status col-status-projetado text-center">Projetado</th>
                    -->

                    <!-- Quantidade -->
                    <ng-template [ngIf]="entityLancamento.controleQuantidade">
                        <th class="col-quantidade col-ano-anterior2 col-quantidade-realizada col-separator text-right">Realizada</th>
                        <th class="col-quantidade col-ano-anterior1 col-quantidade-pretendida text-right" *ngIf="isLancamentoQuantidade()">Pretendida</th>
                        <th class="col-quantidade col-ano-anterior1 col-quantidade-realizada col-separator text-right">Realizada</th>

                        <ng-template [ngIf]="isLancamentoQuantidade()">
                            <th class="col-quantidade col-ano col-valor-unitario text-right" *ngIf="entityLancamento.solicitarPrecoMedio">Preço Médio</th>
                            <th class="col-quantidade col-ano col-quantidade-potencial text-right" *ngIf="configAnaliseMercado?.solicitarPotencial">Sell In Cliente</th>
                            <th class="col-quantidade col-ano col-quantidade-pretendida text-right">
                                <span class="col-quantidade-pretendida-label">Pretendida</span>
                                <span class="col-quantidade-pretendida-label-customer-share" [title]="KPI_CUSTOMER_SHARE.nome">{{KPI_CUSTOMER_SHARE.nome}}</span>
                            </th>
                            <th class="col-quantidade col-ano col-valor-unitario-projetado text-right" *ngIf="showProjetado && entityLancamento.solicitarPrecoMedio">Preço Médio <br/> Projetado</th>
                            <th class="col-quantidade col-ano col-quantidade-projetada text-right" *ngIf="showProjetado">Projetada</th>
                        </ng-template>

                        <th class="col-quantidade col-ano col-quantidade-realizada text-right" [class.col-separator]="!isLancamentoQuantidade()">Realizada</th>
                        <th class="col-quantidade col-ano col-quantidade-pretendida-perc-evolucao col-separator text-right" *ngIf="isLancamentoQuantidade()">Evolução</th>
                    </ng-template>

                    <!-- Peso -->
                    <ng-template [ngIf]="entityLancamento.controlePeso">
                        <th class="col-peso col-ano-anterior2 col-peso-realizado col-separator text-right">Realizado</th>
                        <th class="col-peso col-ano-anterior1 col-peso-pretendido text-right" *ngIf="isLancamentoPeso()">Pretendido</th>
                        <th class="col-peso col-ano-anterior1 col-peso-realizado col-separator text-right">Realizado</th>

                        <ng-template [ngIf]="isLancamentoPeso()">
                            <th class="col-peso col-ano col-valor-unitario text-right" *ngIf="entityLancamento.solicitarPrecoMedio">Preço Médio</th>
                            <th class="col-peso col-ano col-peso-potencial text-right" *ngIf="configAnaliseMercado?.solicitarPotencial">Sell In Cliente</th>
                            <th class="col-peso col-ano col-peso-pretendido text-right">
                                <span class="col-peso-pretendido-label">Pretendido</span>
                                <span class="col-peso-pretendido-label-customer-share" [title]="KPI_CUSTOMER_SHARE.nome">{{KPI_CUSTOMER_SHARE.nome}}</span>
                            </th>
                            <th class="col-peso col-ano col-valor-unitario-projetado text-right" *ngIf="showProjetado && entityLancamento.solicitarPrecoMedio">Preço Médio <br/> Projetado</th>
                            <th class="col-peso col-ano col-peso-projetado text-right" *ngIf="showProjetado">Projetado</th>
                        </ng-template>

                        <th class="col-peso col-ano col-peso-realizado text-right" [class.col-separator]="!isLancamentoPeso()">Realizado</th>
                        <th class="col-peso col-ano col-peso-pretendido-perc-evolucao col-separator text-right" *ngIf="isLancamentoPeso()">Evolução</th>
                    </ng-template>

                    <!-- Valor -->
                    <ng-template [ngIf]="entityLancamento.controleValor">
                        <!-- Ano Anterior 2 -->
                        <th class="col-valor col-ano-anterior2 col-valor-realizado col-separator text-right">
                            RAR
                        </th>

                        <!-- Ano Anterior 1 -->
                        <th class="col-valor col-ano-anterior1 col-valor-realizado text-right">
                            RAR
                        </th>
                        <th class="col-valor col-ano-anterior1 col-valor-pretendido  col-separator text-right">
                            RAP
                        </th>

                        <!-- CS RAP -->
                        <th class="col-valor col-ano col-customer-share text-right">
                            Perc. %
                        </th>
                        <th class="col-valor col-ano col-valor-pretendido text-right">
                            Valor
                        </th>
                        <th class="col-valor col-ano col-valor-projetado col-separator text-right" *ngIf="showProjetado">
                            Projetado
                        </th>

                        <!-- CS RAR -->
                        <th class="col-valor col-ano col-valor-realizado text-right">
                            Valor
                        </th>
                        <th class="col-valor col-ano col-valor-pretendido-perc-evolucao text-right" *ngIf="isLancamentoValor()">
                            Evolução
                        </th>
                    </ng-template>
                </tr>
            </thead>
            <!-- Anual -->
            <thead class="anual" [class.active]="isPeriodicidadeAnual()">
                <tr>
                    <th class="col-periodicidade">
                        <div class="col-periodicidade-container">
                            <div class="custom-control custom-radio custom-control-inline">
                                <input type="radio" class="custom-control-input" name="periodicidade" id="periodicidadeAnual"
                                    [value]="periodicidadeAnual.id" [(ngModel)]="entityLancamento.periodicidade" (ngModelChange)="onSelectPeriodicidadeAnual()"
                                    required="required" [attr.disabled]="canEdit == false || null" [attr.readonly]="canEdit == false || null">
                                <label class="custom-control-label" for="periodicidadeAnual">{{periodicidadeAnual.nome}}</label>
                            </div>

                            <!-- Classificação RAP -->
                            <div class="classificacao-rap-form" novalidate *ngIf="config?.isPerspectivaRAP">
                                <label for="classificacaoRAP">Classificação {{KPI_RAP.sigla}}</label>
                                <select class="form-control" name="classificacaoRAP" id="classificacaoRAP"
                                    [ngModel]="entityLancamento.idClassificacaoRAP || ''" (ngModelChange)="onChangeClassificacaoRAP($event ? $event : null)"
                                    #classificacaoRAP="ngModel" [disabled]="!canEdit">
                                    <option value="">SEM CLASSIFICAÇÃO {{KPI_RAP.sigla}}</option>
                                    <option *ngFor="let classificacao of classificacoesRAP" [ngValue]="classificacao.id">{{classificacao.nome | uppercase}}</option>
                                </select>
                            </div>
                        </div>
                    </th>

                    <!--
                    <th class="col-status col-status-pretendido text-center">
                        <sgt-cliente-analise-mercado-status-pretendido-badge-pill
                            [statusPretendido]="entityLancamento.statusPretendido"
                            title="{{entityLancamento.statusPretendido | clienteAnaliseMercadoStatusPretendido}} em {{entityLancamento.ano}}">
                        </sgt-cliente-analise-mercado-status-pretendido-badge-pill>
                    </th>
                    -->
                    <!--
                    <th class="col-status col-status-projetado text-center">
                        <sgt-cliente-analise-mercado-status-projetado-badge-pill
                            [statusProjetado]="entityLancamento.statusProjetado"
                            title="{{entityLancamento.statusProjetado | clienteAnaliseMercadoStatusProjetado}} em {{entityLancamento.ano}}">
                        </sgt-cliente-analise-mercado-status-projetado-badge-pill>
                    </th>
                    -->

                    <!-- Quantidade -->
                    <ng-template [ngIf]="entityLancamento.controleQuantidade">
                        <th class="col-quantidade col-ano-anterior2 col-quantidade-realizada col-separator text-right">
                            {{entityLancamento.quantidadeRealizadaAnoAnterior2 | decimalFormat: 1:0:0}}
                        </th>
                        <th class="col-quantidade col-ano-anterior1 col-quantidade-pretendida text-right" *ngIf="isLancamentoQuantidade()">
                            {{entityLancamento.quantidadePretendidaAnoAnterior1 | decimalFormat: 1:0:0}}
                        </th>
                        <th class="col-quantidade col-ano-anterior1 col-quantidade-realizada col-separator text-right">
                            {{entityLancamento.quantidadeRealizadaAnoAnterior1 | decimalFormat: 1:0:0}}
                        </th>

                        <ng-template [ngIf]="isLancamentoQuantidade()">
                            <th class="col-quantidade col-ano col-valor-unitario text-right" *ngIf="entityLancamento.solicitarPrecoMedio">
                                <ng-template [ngIf]="canEditLancamentoQuantidadeAnual()">
                                    <sgt-decimal2 [ngModel]="entityLancamento.quantidadePretendidaValorUnitario" name="quantidadePretendidaValorUnitarioAnual" id="quantidadePretendidaValorUnitarioAnual"
                                        #quantidadePretendidaValorUnitarioAnual="ngModel" [ngControl]="quantidadePretendidaValorUnitarioAnual" #quantidadePretendidaValorUnitarioDecimalAnual
                                        (ngModelChange)="onChangeQuantidadePretendidaValorUnitarioAnual($event)" [required]="isQuantidadePretendidaValorUnitarioAnualRequired()"
                                        sgtTableTrActive>
                                    </sgt-decimal2>
                                </ng-template>
                                <!-- <ng-template [ngIf]="!canEditLancamentoQuantidadeAnual()">
                                    {{entityLancamento.valorUnitario | decimalFormat: 1:0:0}}
                                </ng-template> -->
                            </th>
                            <th class="col-quantidade col-ano col-quantidade-potencial text-right" *ngIf="configAnaliseMercado?.solicitarPotencial">
                                <sgt-decimal2 [ngModel]="entityLancamento.quantidadePotencial" name="quantidadePotencialAnual" id="quantidadePotencialAnual"
                                    #quantidadePotencialAnual="ngModel" [ngControl]="quantidadePotencialAnual" [digits]="0"
                                    (ngModelChange)="onChangeQuantidadePotencialAnual($event)"
                                    [disabled]="!canEditLancamentoQuantidadeAnual()" [readonly]="!canEditLancamentoQuantidadeAnual()"
                                    sgtTableTrActive>
                                </sgt-decimal2>
                            </th>
                            <th class="col-quantidade col-ano col-quantidade-pretendida text-right">
                                <div class="input-group">
                                    <sgt-decimal2
                                        [ngModel]="entityLancamento.quantidadePretendida" name="quantidadePretendidaAnual" id="quantidadePretendidaAnual"
                                        #quantidadePretendidaAnual="ngModel" [ngControl]="quantidadePretendidaAnual" [digits]="0"
                                        (ngModelChange)="onChangeQuantidadePretendidaAnual($event)"
                                        [disabled]="!canEditLancamentoQuantidadeAnual()" [readonly]="!canEditLancamentoQuantidadeAnual()"
                                        sgtTableTrActive>
                                    </sgt-decimal2>

                                    <ng-template [ngIf]="configAnaliseMercado?.solicitarPotencial">
                                        <div class="input-group-append">
                                            <span class="input-group-text">
                                                |
                                            </span>
                                        </div>
                                        <sgt-decimal2
                                            [ngModel]="entityLancamento.quantidadePretendidaPerc"
                                            class="input-perc" name="quantidadePretendidaPercAnual" id="quantidadePretendidaPercAnual"
                                            #quantidadePretendidaPercAnual="ngModel" [ngControl]="quantidadePretendidaPercAnual" [digits]="0"
                                            (ngModelChange)="onChangeQuantidadePretendidaPercAnual($event)"
                                            [disabled]="!canEditLancamentoQuantidadeAnual()" [readonly]="!canEditLancamentoQuantidadeAnual()"
                                            sgtTableTrActive>
                                        </sgt-decimal2>
                                        <div class="input-group-append">
                                            <span class="input-group-text">
                                                %
                                            </span>
                                        </div>
                                    </ng-template>
                                </div>
                            </th>
                            <th class="col-quantidade col-ano col-valor-unitario-projetado text-right" *ngIf="showProjetado && entityLancamento.solicitarPrecoMedio">
                                <ng-template [ngIf]="canEditLancamentoQuantidadeAnual()">
                                    {{entityLancamento.quantidadeProjetadaValorUnitario | decimalFormat: 1:2:2}}
                                </ng-template>
                            </th>
                            <th class="col-quantidade col-ano col-quantidade-projetada text-right" *ngIf="showProjetado">
                                <!-- <sgt-decimal2 [ngModel]="entityLancamento.quantidadeProjetada" name="quantidadeProjetadaAnual" id="quantidadeProjetadaAnual"
                                    #quantidadeProjetadaAnual="ngModel" [ngControl]="quantidadeProjetadaAnual" [digits]="0"
                                    (ngModelChange)="onChangeQuantidadeProjetadaAnual($event)"
                                    sgtTableTrActive>
                                </sgt-decimal2>  -->

                                {{entityLancamento.quantidadeProjetada | decimalFormat: 1:0:0}}
                                <span *ngIf="configAnaliseMercado?.solicitarPotencial">
                                    | {{entityLancamento.quantidadeProjetadaPerc | decimalFormat: 1:0:0}}%
                                </span>
                            </th>
                        </ng-template>

                        <th class="col-quantidade col-ano col-quantidade-realizada text-right" [class.col-separator]="!isLancamentoQuantidade()">
                            {{entityLancamento.quantidadeRealizada | decimalFormat: 1:0:0}}
                            <!-- <span *ngIf="isLancamentoQuantidade()">
                                | {{entityLancamento.quantidadeRealizadaPercPretendida | decimalFormat: 1:0:0}}%
                            </span> -->
                        </th>
                        <th class="col-quantidade col-ano col-quantidade-pretendida-perc-evolucao col-separator text-right" *ngIf="isLancamentoQuantidade()">
                            {{entityLancamento.quantidadePretendidaPercEvolucao | decimalFormat: 1:0:0}}%
                        </th>
                    </ng-template>

                    <!-- Peso -->
                    <ng-template [ngIf]="entityLancamento.controlePeso">
                        <th class="col-peso col-ano-anterior2 col-peso-realizado col-separator text-right">
                            {{entityLancamento.pesoRealizadoAnoAnterior2 | decimalFormat: 1:0:0}}
                        </th>
                        <th class="col-peso col-ano-anterior1 col-peso-pretendido text-right" *ngIf="isLancamentoPeso()">
                            {{entityLancamento.pesoPretendidoAnoAnterior1 | decimalFormat: 1:0:0}}
                        </th>
                        <th class="col-peso col-ano-anterior1 col-peso-realizado col-separator text-right">
                            {{entityLancamento.pesoRealizadoAnoAnterior1 | decimalFormat: 1:0:0}}
                        </th>

                        <ng-template [ngIf]="isLancamentoPeso()">
                            <th class="col-peso col-ano col-valor-unitario text-right" *ngIf="entityLancamento.solicitarPrecoMedio">
                                <ng-template [ngIf]="canEditLancamentoPesoAnual()">
                                    <sgt-decimal2 [ngModel]="entityLancamento.pesoPretendidoValorUnitario" name="pesoPretendidoValorUnitarioAnual" id="pesoPretendidoValorUnitarioAnual"
                                        #pesoPretendidoValorUnitarioAnual="ngModel" [ngControl]="pesoPretendidoValorUnitarioAnual" #pesoPretendidoValorUnitarioDecimalAnual
                                        (ngModelChange)="onChangePesoPretendidoValorUnitarioAnual($event)" [required]="isPesoPretendidoValorUnitarioAnualRequired()"
                                        sgtTableTrActive>
                                    </sgt-decimal2>
                                </ng-template>
                                <!-- <ng-template [ngIf]="!canEditLancamentoPesoAnual()">
                                    {{entityLancamento.valorUnitario | decimalFormat: 1:2:2}}
                                </ng-template> -->
                            </th>
                            <th class="col-peso col-ano col-peso-potencial text-right" *ngIf="configAnaliseMercado?.solicitarPotencial">
                                <sgt-decimal2 [ngModel]="entityLancamento.pesoPotencial" name="pesoPotencialAnual" id="pesoPotencialAnual"
                                    #pesoPotencialAnual="ngModel" [ngControl]="pesoPotencialAnual" [digits]="0"
                                    (ngModelChange)="onChangePesoPotencialAnual($event)"
                                    [disabled]="!canEditLancamentoPesoAnual()" [readonly]="!canEditLancamentoPesoAnual()"
                                    sgtTableTrActive>
                                </sgt-decimal2>
                            </th>
                            <th class="col-peso col-ano col-peso-pretendido text-right">
                                <div class="input-group">
                                    <sgt-decimal2
                                        [ngModel]="entityLancamento.pesoPretendido"
                                        name="pesoPretendidoAnual" id="pesoPretendidoAnual"
                                        #pesoPretendidoAnual="ngModel" [ngControl]="pesoPretendidoAnual" [digits]="0"
                                        (ngModelChange)="onChangePesoPretendidoAnual($event)"
                                        [disabled]="!canEditLancamentoPesoAnual()" [readonly]="!canEditLancamentoPesoAnual()"
                                        sgtTableTrActive>
                                    </sgt-decimal2>

                                    <ng-template [ngIf]="configAnaliseMercado?.solicitarPotencial">
                                        <div class="input-group-append">
                                            <span class="input-group-text">
                                                |
                                            </span>
                                        </div>
                                        <sgt-decimal2
                                            [ngModel]="entityLancamento.pesoPretendidoPerc"
                                            class="input-perc"
                                            name="pesoPretendidoPercAnual" id="pesoPretendidoPercAnual"
                                            #pesoPretendidoPercAnual="ngModel" [ngControl]="pesoPretendidoPercAnual" [digits]="0"
                                            (ngModelChange)="onChangePesoPretendidoPercAnual($event)"
                                            [disabled]="!canEditLancamentoPesoAnual()" [readonly]="!canEditLancamentoPesoAnual()"
                                            sgtTableTrActive>
                                        </sgt-decimal2>
                                        <div class="input-group-append">
                                            <span class="input-group-text">
                                                %
                                            </span>
                                        </div>
                                    </ng-template>
                                </div>
                            </th>
                            <th class="col-peso col-ano col-valor-unitario-projetado text-right" *ngIf="showProjetado && entityLancamento.solicitarPrecoMedio">
                                <ng-template [ngIf]="canEditLancamentoPesoAnual()">
                                    {{entityLancamento.pesoProjetadoValorUnitario | decimalFormat: 1:2:2}}
                                </ng-template>
                            </th>
                            <th class="col-peso col-ano col-peso-projetado text-right" *ngIf="showProjetado">
                                <!-- <sgt-decimal2 [ngModel]="entityLancamento.pesoProjetado" name="pesoProjetadoAnual" id="pesoProjetadoAnual"
                                    #pesoProjetadoAnual="ngModel" [ngControl]="pesoProjetadoAnual" [digits]="0"
                                    (ngModelChange)="onChangePesoProjetadoAnual($event)"
                                    sgtTableTrActive>
                                </sgt-decimal2>                                      -->

                                {{entityLancamento.pesoProjetado | decimalFormat: 1:0:0}}
                                <span *ngIf="configAnaliseMercado?.solicitarPotencial">
                                    | {{entityLancamento.pesoProjetadoPerc | decimalFormat: 1:0:0}}%
                                </span>
                            </th>
                        </ng-template>

                        <th class="col-peso col-ano col-peso-realizado text-right" [class.col-separator]="!isLancamentoPeso()">
                            {{entityLancamento.pesoRealizado | decimalFormat: 1:0:0}}
                            <!-- <span *ngIf="isLancamentoPeso()">
                                | {{entityLancamento.pesoRealizadoPercPretendido | decimalFormat: 1:0:0}}%
                            </span> -->
                        </th>
                        <th class="col-peso col-ano col-peso-pretendido-perc-evolucao col-separator text-right" *ngIf="isLancamentoPeso()">
                            {{entityLancamento.pesoPretendidoPercEvolucao | decimalFormat: 1:0:0}}%
                        </th>
                    </ng-template>

                    <!-- Valor -->
                    <ng-template [ngIf]="entityLancamento.controleValor">
                        <!-- Ano Anterior 2 -->
                        <th class="col-valor col-ano-anterior2 col-valor-realizado col-separator text-right">
                            {{entityLancamento.valorRealizadoAnoAnterior2 | decimalFormat: 1:0:0}}
                        </th>

                        <!-- Ano Anterior 1 -->
                        <th class="col-valor col-ano-anterior1 col-valor-realizado text-right">
                            {{entityLancamento.valorRealizadoAnoAnterior1 | decimalFormat: 1:0:0}}
                        </th>
                        <th class="col-valor col-ano-anterior1 col-valor-pretendido col-separator text-right">
                            {{entityLancamento.valorPretendidoAnoAnterior1 | decimalFormat: 1:0:0}}
                        </th>

                        <!-- Sell In Cliente -->
                        <th class="col-valor col-ano col-valor-potencial col-separator text-right" *ngIf="configAnaliseMercado?.solicitarPotencial && isLancamentoValor()">
                            <sgt-decimal2 [ngModel]="entityLancamento.valorPotencial" name="valorPotencialAnual" id="valorPotencialAnual"
                                #valorPotencialAnual="ngModel" [ngControl]="valorPotencialAnual" [digits]="0"
                                (ngModelChange)="onChangeValorPotencialAnual($event)"
                                [disabled]="!canEditLancamentoValorAnual()" [readonly]="!canEditLancamentoValorAnual()"
                                sgtTableTrActive>
                            </sgt-decimal2>
                        </th>

                        <!-- CS RAP -->
                        <th class="col-valor col-ano col-customer-share text-right">
                            <div class="input-group">
                                <sgt-decimal2 [ngModel]="entityLancamento.valorPretendidoPerc"
                                    class="input-perc" name="valorPretendidoPercAnual" id="valorPretendidoPercAnual"
                                    #valorPretendidoPercAnual="ngModel" [ngControl]="valorPretendidoPercAnual" [digits]="0"
                                    (ngModelChange)="onChangeValorPretendidoPercAnual($event)"
                                    [disabled]="!canEditLancamentoValorAnual()" [readonly]="!canEditLancamentoValorAnual()"
                                    sgtTableTrActive>
                                </sgt-decimal2>
                                <div class="input-group-append">
                                    <span class="input-group-text">
                                        %
                                    </span>
                                </div>
                                <div class="input-group-append">
                                    <span class="input-group-text">
                                        <sgt-customer-share-indicador-badge
                                            [indicador]="entityLancamento.indicadorCustomerSharePretendido"
                                            fontSize="8px"
                                            padding="4px"
                                            width="47px">
                                        </sgt-customer-share-indicador-badge>
                                    </span>
                                </div>
                            </div>
                        </th>
                        <th class="col-valor col-ano col-valor-pretendido text-right">
                            <sgt-decimal2 [ngModel]="entityLancamento.valorPretendido" name="valorPretendidoAnual" id="valorPretendidoAnual"
                                #valorPretendidoAnual="ngModel" [ngControl]="valorPretendidoAnual" [digits]="0"
                                (ngModelChange)="onChangeValorPretendidoAnual($event, true)"
                                [disabled]="!canEditLancamentoValorAnual()" [readonly]="!canEditLancamentoValorAnual()"
                                sgtTableTrActive>
                            </sgt-decimal2>
                        </th>
                        <th class="col-valor col-ano col-valor-projetado col-separator text-right" *ngIf="showProjetado">
                            <!-- <sgt-decimal2 [ngModel]="entityLancamento.valorProjetado" name="valorProjetadoAnual" id="valorProjetadoAnual"
                                #valorProjetadoAnual="ngModel" [ngControl]="valorProjetadoAnual" [digits]="0"
                                (ngModelChange)="onChangeValorProjetadoAnual($event)"
                                sgtTableTrActive>
                            </sgt-decimal2> -->

                            {{(entityLancamento.valorProjetado ? entityLancamento.valorProjetado : 0) | decimalFormat: 1:0:0}}
                            <span *ngIf="configAnaliseMercado?.solicitarPotencial">
                                | {{entityLancamento.valorProjetadoPerc | decimalFormat: 1:0:0}}%
                            </span>
                        </th>

                        <!-- CS RAR -->
                        <th class="col-valor col-ano col-valor-realizado text-right">
                            {{entityLancamento.valorRealizado | decimalFormat: 1:0:0}}
                            <!-- <span>
                                | {{entityLancamento.valorRealizadoPercPretendido | decimalFormat: 1:0:0}}%
                            </span> -->
                        </th>
                        <th class="col-valor col-ano col-valor-pretendido-perc-evolucao text-right" *ngIf="isLancamentoValor()">
                            {{entityLancamento.valorPretendidoPercEvolucao | decimalFormat: 1:0:0}}%
                        </th>
                    </ng-template>
                </tr>
            </thead>
            <!-- Média Mensal -->
            <thead class="media-mensal" [class.active]="isPeriodicidadeMediaMensal()">
                <tr>
                    <th class="col-periodicidade">
                        <div class="custom-control custom-radio custom-control-inline">
                            <input type="radio" class="custom-control-input" name="periodicidade" id="periodicidadeMediaMensal"
                                [value]="periodicidadeMediaMensal.id" [(ngModel)]="entityLancamento.periodicidade" (ngModelChange)="onSelectPeriodicidadeMediaMensal()"
                                required="required" [attr.disabled]="canEdit == false || null" [attr.readonly]="canEdit == false || null">
                            <label class="custom-control-label" for="periodicidadeMediaMensal">{{periodicidadeMediaMensal.nome}}</label>
                        </div>
                    </th>

                    <!--
                    <th class="col-status col-status-pretendido text-center"></th>
                    <th class="col-status col-status-projetado text-center"></th>
                    -->

                    <!-- Quantidade -->
                    <ng-template [ngIf]="entityLancamento.controleQuantidade">
                        <th class="col-quantidade col-ano-anterior2 col-quantidade-realizada col-separator text-right">
                            {{entityLancamento.quantidadeRealizadaMediaMensalAnoAnterior2 | decimalFormat: 1:0:0}}
                        </th>
                        <th class="col-quantidade col-ano-anterior1 col-quantidade-pretendida text-right" *ngIf="isLancamentoQuantidade()">
                            {{entityLancamento.quantidadePretendidaMediaMensalAnoAnterior1 | decimalFormat: 1:0:0}}
                        </th>
                        <th class="col-quantidade col-ano-anterior1 col-quantidade-realizada col-separator text-right">
                            {{entityLancamento.quantidadeRealizadaMediaMensalAnoAnterior1 | decimalFormat: 1:0:0}}
                        </th>

                        <ng-template [ngIf]="isLancamentoQuantidade()">
                            <th class="col-quantidade col-ano col-valor-unitario text-right" *ngIf="entityLancamento.solicitarPrecoMedio">
                                <ng-template [ngIf]="canEditLancamentoQuantidadeMediaMensal()">
                                    <sgt-decimal2 [ngModel]="entityLancamento.quantidadePretendidaValorUnitario" name="quantidadePretendidaValorUnitarioMedioMensal" id="quantidadePretendidaValorUnitarioMedioMensal"
                                        #quantidadePretendidaValorUnitarioMedioMensal="ngModel" [ngControl]="quantidadePretendidaValorUnitarioMedioMensal" #quantidadePretendidaValorUnitarioDecimalMediaMensal
                                        (ngModelChange)="onChangeQuantidadePretendidaValorUnitarioMedioMensal($event)" [required]="isQuantidadePretendidaValorUnitarioMediaMensalRequired()"
                                        sgtTableTrActive>
                                    </sgt-decimal2>
                                </ng-template>
                                <!-- <ng-template [ngIf]="!canEditLancamentoQuantidadeMediaMensal()">
                                    {{entityLancamento.valorUnitario | decimalFormat: 1:2:2}}
                                </ng-template>                                                 -->
                            </th>
                            <th class="col-quantidade col-ano col-quantidade-potencial text-right" *ngIf="configAnaliseMercado?.solicitarPotencial">
                                <sgt-decimal2 [ngModel]="entityLancamento.quantidadePotencialMediaMensal" name="quantidadePotencialMediaMensal" id="quantidadePotencialMediaMensal"
                                    #quantidadePotencialMediaMensal="ngModel" [ngControl]="quantidadePotencialMediaMensal" [digits]="0"
                                    (ngModelChange)="onChangeQuantidadePotencialMediaMensal($event)"
                                    [disabled]="!canEditLancamentoQuantidadeMediaMensal()" [readonly]="!canEditLancamentoQuantidadeMediaMensal()"
                                    sgtTableTrActive>
                                </sgt-decimal2>
                            </th>
                            <th class="col-quantidade col-ano col-quantidade-pretendida text-right">
                                <div class="input-group">
                                    <sgt-decimal2 [ngModel]="entityLancamento.quantidadePretendidaMediaMensal" name="quantidadePretendidaMediaMensal" id="quantidadePretendidaMediaMensal"
                                        #quantidadePretendidaMediaMensal="ngModel" [ngControl]="quantidadePretendidaMediaMensal" [digits]="0"
                                        (ngModelChange)="onChangeQuantidadePretendidaMediaMensal($event)"
                                        [disabled]="!canEditLancamentoQuantidadeMediaMensal()" [readonly]="!canEditLancamentoQuantidadeMediaMensal()"
                                        sgtTableTrActive>
                                    </sgt-decimal2>

                                    <ng-template [ngIf]="configAnaliseMercado?.solicitarPotencial">
                                        <div class="input-group-append">
                                            <span class="input-group-text">
                                                |
                                            </span>
                                        </div>
                                        <sgt-decimal2
                                            [ngModel]="entityLancamento.quantidadePretendidaPerc"
                                            class="input-perc" name="quantidadePretendidaPercMediaMensal" id="quantidadePretendidaPercMediaMensal"
                                            #quantidadePretendidaPercMediaMensal="ngModel" [ngControl]="quantidadePretendidaPercMediaMensal" [digits]="0"
                                            (ngModelChange)="onChangeQuantidadePretendidaPercMediaMensal($event)"
                                            [disabled]="!canEditLancamentoQuantidadeMediaMensal()" [readonly]="!canEditLancamentoQuantidadeMediaMensal()"
                                            sgtTableTrActive>
                                        </sgt-decimal2>
                                    </ng-template>
                                    <div class="input-group-append">
                                        <span class="input-group-text">
                                            %
                                        </span>
                                    </div>
                                </div>
                            </th>
                            <th class="col-quantidade col-ano col-valor-unitario-projetado text-right" *ngIf="showProjetado && entityLancamento.solicitarPrecoMedio">
                                <ng-template [ngIf]="canEditLancamentoQuantidadeMediaMensal()">
                                    {{entityLancamento.quantidadeProjetadaValorUnitario | decimalFormat: 1:2:2}}
                                </ng-template>
                            </th>
                            <th class="col-quantidade col-ano col-quantidade-projetada text-right" *ngIf="showProjetado">
                                <!-- <sgt-decimal2 [ngModel]="entityLancamento.quantidadeProjetadaMediaMensal" name="quantidadeProjetadaMediaMensal" id="quantidadeProjetadaMediaMensal"
                                    #quantidadeProjetadaMediaMensal="ngModel" [ngControl]="quantidadeProjetadaMediaMensal" [digits]="0"
                                    (ngModelChange)="onChangeQuantidadeProjetadaMediaMensal($event)"
                                    sgtTableTrActive>
                                </sgt-decimal2>                                     -->

                                {{entityLancamento.quantidadeProjetadaMediaMensal | decimalFormat: 1:0:0}}
                                <span *ngIf="configAnaliseMercado?.solicitarPotencial">
                                    | {{entityLancamento.quantidadeProjetadaPerc | decimalFormat: 1:0:0}}%
                                </span>
                            </th>
                        </ng-template>

                        <th class="col-quantidade col-ano col-quantidade-realizada text-right" [class.col-separator]="!isLancamentoQuantidade()">
                            {{entityLancamento.quantidadeRealizadaMediaMensal | decimalFormat: 1:0:0}}
                            <!-- <span *ngIf="isLancamentoQuantidade()">
                                | {{entityLancamento.quantidadeRealizadaPercPretendida | decimalFormat: 1:0:0}}%
                            </span> -->
                        </th>
                        <th class="col-quantidade col-ano col-quantidade-pretendida-perc-evolucao col-separator text-right" *ngIf="isLancamentoQuantidade()">
                            {{entityLancamento.quantidadePretendidaPercEvolucao | decimalFormat: 1:0:0}}%
                        </th>
                    </ng-template>

                    <!-- Peso -->
                    <ng-template [ngIf]="entityLancamento.controlePeso">
                        <th class="col-peso col-ano-anterior2 col-peso-realizado col-separator text-right">
                            {{entityLancamento.pesoRealizadoMedioMensalAnoAnterior2 | decimalFormat: 1:0:0}}
                        </th>
                        <th class="col-peso col-ano-anterior1 col-peso-pretendido text-right" *ngIf="isLancamentoPeso()">
                            {{entityLancamento.pesoPretendidoMedioMensalAnoAnterior1 | decimalFormat: 1:0:0}}
                        </th>
                        <th class="col-peso col-ano-anterior1 col-peso-realizado col-separator text-right">
                            {{entityLancamento.pesoRealizadoMedioMensalAnoAnterior1 | decimalFormat: 1:0:0}}
                        </th>

                        <ng-template [ngIf]="isLancamentoPeso()">
                            <th class="col-peso col-ano col-valor-unitario text-right" *ngIf="entityLancamento.solicitarPrecoMedio">
                                <ng-template [ngIf]="canEditLancamentoPesoMediaMensal()">
                                    <sgt-decimal2 [ngModel]="entityLancamento.pesoPretendidoValorUnitario" name="pesoPretendidoValorUnitarioMedioMensal" id="pesoPretendidoValorUnitarioMedioMensal"
                                        #pesoPretendidoValorUnitarioMedioMensal="ngModel" [ngControl]="pesoPretendidoValorUnitarioMedioMensal" #pesoPretendidoValorUnitarioDecimalMediaMensal
                                        (ngModelChange)="onChangePesoPretendidoValorUnitarioMedioMensal($event)" [required]="isPesoPretendidoValorUnitarioMediaMensalRequired()"
                                        sgtTableTrActive>
                                    </sgt-decimal2>
                                </ng-template>
                                <!-- <ng-template [ngIf]="!canEditLancamentoPesoMediaMensal()">
                                    {{entityLancamento.valorUnitario | decimalFormat: 1:2:2}}
                                </ng-template>                                                 -->
                            </th>
                            <th class="col-peso col-ano col-peso-potencial text-right" *ngIf="configAnaliseMercado?.solicitarPotencial">
                                <sgt-decimal2 [ngModel]="entityLancamento.pesoPotencialMedioMensal" name="pesoPotencialMedioMensal" id="pesoPotencialMedioMensal"
                                    #pesoPotencialMedioMensal="ngModel" [ngControl]="pesoPotencialMedioMensal" [digits]="0"
                                    (ngModelChange)="onChangePesoPotencialMedioMensal($event)"
                                    [disabled]="!canEditLancamentoPesoMediaMensal()" [readonly]="!canEditLancamentoPesoMediaMensal()"
                                    sgtTableTrActive>
                                </sgt-decimal2>
                            </th>
                            <th class="col-peso col-ano col-peso-pretendido text-right">
                                <div class="input-group">
                                    <sgt-decimal2 [ngModel]="entityLancamento.pesoPretendidoMedioMensal" name="pesoPretendidoMedioMensal" id="pesoPretendidoMedioMensal"
                                        #pesoPretendidoMedioMensal="ngModel" [ngControl]="pesoPretendidoMedioMensal" [digits]="0"
                                        (ngModelChange)="onChangePesoPretendidoMedioMensal($event)"
                                        [disabled]="!canEditLancamentoPesoMediaMensal()" [readonly]="!canEditLancamentoPesoMediaMensal()"
                                        sgtTableTrActive>
                                    </sgt-decimal2>

                                    <ng-template [ngIf]="configAnaliseMercado?.solicitarPotencial">
                                        <div class="input-group-append">
                                            <span class="input-group-text">
                                                |
                                            </span>
                                        </div>
                                        <sgt-decimal2 [ngModel]="entityLancamento.pesoPretendidoPerc"
                                            class="input-perc" name="pesoPretendidoPercMedioMensal" id="pesoPretendidoPercMedioMensal"
                                            #pesoPretendidoPercMedioMensal="ngModel" [ngControl]="pesoPretendidoPercMedioMensal" [digits]="0"
                                            (ngModelChange)="onChangePesoPretendidoPercMedioMensal($event)"
                                            [disabled]="!canEditLancamentoPesoMediaMensal()" [readonly]="!canEditLancamentoPesoMediaMensal()"
                                            sgtTableTrActive>
                                        </sgt-decimal2>
                                    </ng-template>
                                    <div class="input-group-append">
                                        <span class="input-group-text">
                                            %
                                        </span>
                                    </div>
                                </div>
                            </th>
                            <th class="col-peso col-ano col-valor-unitario-projetado text-right" *ngIf="showProjetado && entityLancamento.solicitarPrecoMedio">
                                <ng-template [ngIf]="canEditLancamentoPesoMediaMensal()">
                                    {{entityLancamento.pesoProjetadoValorUnitario | decimalFormat: 1:2:2}}
                                </ng-template>
                            </th>
                            <th class="col-peso col-ano col-peso-projetado text-right" *ngIf="showProjetado">
                                <!-- <sgt-decimal2 [ngModel]="entityLancamento.pesoProjetadoMedioMensal" name="pesoProjetadoMedioMensal" id="pesoProjetadoMedioMensal"
                                    #pesoProjetadoMedioMensal="ngModel" [ngControl]="pesoProjetadoMedioMensal" [digits]="0"
                                    (ngModelChange)="onChangePesoProjetadoMedioMensal($event)"
                                    sgtTableTrActive>
                                </sgt-decimal2>                                     -->

                                {{entityLancamento.pesoProjetadoMedioMensal | decimalFormat: 1:0:0}}
                                <span *ngIf="configAnaliseMercado?.solicitarPotencial">
                                    | {{entityLancamento.pesoProjetadoPerc | decimalFormat: 1:0:0}}%
                                </span>
                            </th>
                        </ng-template>

                        <th class="col-peso col-ano col-peso-realizado text-right" [class.col-separator]="!isLancamentoPeso()">
                            {{entityLancamento.pesoRealizadoMedioMensal | decimalFormat: 1:0:0}}
                            <!-- <span *ngIf="isLancamentoPeso()">
                                | {{entityLancamento.pesoRealizadoPercPretendido | decimalFormat: 1:0:0}}%
                            </span> -->
                        </th>
                        <th class="col-peso col-ano col-peso-pretendido-perc-evolucao col-separator text-right" *ngIf="isLancamentoPeso()">
                            {{entityLancamento.pesoPretendidoPercEvolucao | decimalFormat: 1:0:0}}%
                        </th>
                    </ng-template>

                    <!-- Valor -->
                    <ng-template [ngIf]="entityLancamento.controleValor">
                        <!-- Ano Anterior 2 -->
                        <th class="col-valor col-ano-anterior2 col-valor-realizado col-separator text-right">
                            {{entityLancamento.valorRealizadoMedioMensalAnoAnterior2 | decimalFormat: 1:0:0}}
                        </th>

                        <!-- Ano Anterior 1 -->
                        <th class="col-valor col-ano-anterior1 col-valor-realizado text-right">
                            {{entityLancamento.valorRealizadoMedioMensalAnoAnterior1 | decimalFormat: 1:0:0}}
                        </th>
                        <th class="col-valor col-ano-anterior1 col-valor-pretendido col-separator text-right">
                            {{entityLancamento.valorPretendidoMedioMensalAnoAnterior1 | decimalFormat: 1:0:0}}
                        </th>

                        <!-- Sell In Cliente -->
                        <th class="col-valor col-ano col-valor-potencial col-separator text-right" *ngIf="configAnaliseMercado?.solicitarPotencial && isLancamentoValor()">
                            <sgt-decimal2 [ngModel]="entityLancamento.valorPotencialMedioMensal" name="valorPotencialMedioMensal" id="valorPotencialMedioMensal"
                                #valorPotencialMedioMensal="ngModel" [ngControl]="valorPotencialMedioMensal" [digits]="0"
                                (ngModelChange)="onChangeValorPotencialMedioMensal($event)"
                                [disabled]="!canEditLancamentoValorMediaMensal()" [readonly]="!canEditLancamentoValorMediaMensal()"
                                sgtTableTrActive>
                            </sgt-decimal2>
                        </th>

                        <!-- CS RAP -->
                        <th class="col-valor col-ano col-customer-share text-right">
                            <div class="input-group">
                                <sgt-decimal2 [ngModel]="entityLancamento.valorPretendidoPerc"
                                    class="input-perc" name="valorPretendidoPercMedioMensal" id="valorPretendidoPercMedioMensal"
                                    #valorPretendidoPercMedioMensal="ngModel" [ngControl]="valorPretendidoPercMedioMensal" [digits]="0"
                                    (ngModelChange)="onChangeValorPretendidoPercMedioMensal($event)"
                                    [disabled]="!canEditLancamentoValorMediaMensal()" [readonly]="!canEditLancamentoValorMediaMensal()"
                                    sgtTableTrActive>
                                </sgt-decimal2>
                                <div class="input-group-append">
                                    <span class="input-group-text">
                                        %
                                    </span>
                                </div>
                                <div class="input-group-append">
                                    <span class="input-group-text">
                                        <sgt-customer-share-indicador-badge
                                            [indicador]="entityLancamento.indicadorCustomerSharePretendido"
                                            fontSize="8px"
                                            padding="4px"
                                            width="47px">
                                        </sgt-customer-share-indicador-badge>
                                    </span>
                                </div>
                            </div>
                        </th>
                        <th class="col-valor col-ano col-valor-pretendido text-right">
                            <sgt-decimal2 [ngModel]="entityLancamento.valorPretendidoMedioMensal" name="valorPretendidoMedioMensal" id="valorPretendidoMedioMensal"
                                #valorPretendidoMedioMensal="ngModel" [ngControl]="valorPretendidoMedioMensal" [digits]="0"
                                (ngModelChange)="onChangeValorPretendidoMedioMensal($event, true)"
                                [disabled]="!canEditLancamentoValorMediaMensal()" [readonly]="!canEditLancamentoValorMediaMensal()"
                                sgtTableTrActive>
                            </sgt-decimal2>
                        </th>
                        <th class="col-valor col-ano col-valor-projetado col-separator text-right" *ngIf="showProjetado">
                            <!-- <sgt-decimal2 [ngModel]="entityLancamento.valorProjetadoMedioMensal" name="valorProjetadoMedioMensal" id="valorProjetadoMedioMensal"
                                #valorProjetadoMedioMensal="ngModel" [ngControl]="valorProjetadoMedioMensal" [digits]="0"
                                (ngModelChange)="onChangeValorProjetadoMedioMensal($event)"
                                sgtTableTrActive>
                            </sgt-decimal2> -->

                            {{entityLancamento.valorProjetadoMedioMensal | decimalFormat: 1:0:0}}
                            <span *ngIf="configAnaliseMercado?.solicitarPotencial">
                                | {{entityLancamento.valorProjetadoPerc | decimalFormat: 1:0:0}}%
                            </span>
                        </th>

                        <!-- CS RAR -->
                        <th class="col-valor col-ano col-valor-realizado text-right">
                            {{entityLancamento.valorRealizadoMedioMensal | decimalFormat: 1:0:0}}
                            <!-- <span>
                                | {{entityLancamento.valorRealizadoPercPretendido | decimalFormat: 1:0:0}}%
                            </span> -->
                        </th>
                        <th class="col-valor col-ano col-valor-pretendido-perc-evolucao text-right" *ngIf="isLancamentoValor()">
                            {{entityLancamento.valorPretendidoPercEvolucao | decimalFormat: 1:0:0}}%
                        </th>
                    </ng-template>
                </tr>
            </thead>
            <!-- Mensal -->
            <tbody class="mensal" [class.active]="isPeriodicidadeMensal()" #tbodyMensal>
                <tr class="mensal-title">
                    <td class="col-periodicidade">
                        <div class="custom-control custom-radio custom-control-inline">
                            <input type="radio" class="custom-control-input" name="periodicidade" id="periodicidadeMensal"
                                [value]="periodicidadeMensal.id" [(ngModel)]="entityLancamento.periodicidade"
                                required="required" [attr.disabled]="canEdit == false || null" [attr.readonly]="canEdit == false || null">
                            <label class="custom-control-label" for="periodicidadeMensal">{{periodicidadeMensal.nome}}</label>
                        </div>
                    </td>

                    <!--
                    <td class="col-status col-status-pretendido text-center"></td>
                    <td class="col-status col-status-projetado text-center"></td>
                    -->

                    <!-- Quantidade -->
                    <ng-template [ngIf]="entityLancamento.controleQuantidade">
                        <td class="col-quantidade col-ano-anterior2 col-quantidade-realizada col-separator text-right"></td>
                        <td class="col-quantidade col-ano-anterior1 col-quantidade-pretendida text-right" *ngIf="isLancamentoQuantidade()"></td>
                        <td class="col-quantidade col-ano-anterior1 col-quantidade-realizada col-separator text-right"></td>

                        <ng-template [ngIf]="isLancamentoQuantidade()">
                            <td class="col-quantidade col-ano col-valor-unitario text-right" *ngIf="entityLancamento.solicitarPrecoMedio"></td>
                            <td class="col-quantidade col-ano col-quantidade-potencial text-right" *ngIf="configAnaliseMercado?.solicitarPotencial"></td>
                            <td class="col-quantidade col-ano col-quantidade-pretendida text-right"></td>
                            <td class="col-quantidade col-ano col-valor-unitario-projetado text-right" *ngIf="showProjetado && entityLancamento.solicitarPrecoMedio"></td>
                            <td class="col-quantidade col-ano col-quantidade-projetada text-right" *ngIf="showProjetado"></td>
                        </ng-template>

                        <td class="col-quantidade col-ano col-quantidade-realizada text-right" [class.col-separator]="!isLancamentoQuantidade()"></td>
                        <td class="col-quantidade col-ano col-quantidade-pretendida-perc-evolucao col-separator text-right" *ngIf="isLancamentoQuantidade()"></td>
                    </ng-template>

                    <!-- Peso -->
                    <ng-template [ngIf]="entityLancamento.controlePeso">
                        <td class="col-peso col-ano-anterior2 col-peso-realizado col-separator text-right"></td>
                        <td class="col-peso col-ano-anterior1 col-peso-pretendido text-right" *ngIf="isLancamentoPeso()"></td>
                        <td class="col-peso col-ano-anterior1 col-peso-realizado col-separator text-right"></td>

                        <ng-template [ngIf]="isLancamentoPeso()">
                            <td class="col-peso col-ano col-valor-unitario text-right" *ngIf="entityLancamento.solicitarPrecoMedio"></td>
                            <td class="col-peso col-ano col-peso-potencial text-right" *ngIf="configAnaliseMercado?.solicitarPotencial"></td>
                            <td class="col-peso col-ano col-peso-pretendido text-right"></td>
                            <td class="col-peso col-ano col-valor-unitario-projetado text-right" *ngIf="showProjetado && entityLancamento.solicitarPrecoMedio"></td>
                            <td class="col-peso col-ano col-peso-projetado text-right" *ngIf="showProjetado"></td>
                        </ng-template>

                        <td class="col-peso col-ano col-peso-realizado text-right" [class.col-separator]="!isLancamentoPeso()"></td>
                        <td class="col-peso col-ano col-peso-pretendido-perc-evolucao col-separator text-right" *ngIf="isLancamentoPeso()"></td>
                    </ng-template>

                    <!-- Valor -->
                    <ng-template [ngIf]="entityLancamento.controleValor">
                        <!-- Ano Anterior 2 -->
                        <td class="col-valor col-ano-anterior2 col-valor-realizado col-separator text-right"></td>

                        <!-- Ano Anterior 1 -->
                        <td class="col-valor col-ano-anterior1 col-valor-realizado text-right"></td>
                        <td class="col-valor col-ano-anterior1 col-valor-pretendido col-separator text-right"></td>

                        <!-- Sell In Cliente -->
                        <td class="col-valor col-ano col-valor-potencial text-right col-separator" *ngIf="configAnaliseMercado?.solicitarPotencial && isLancamentoValor()"></td>

                        <!-- CS RAP -->
                        <td class="col-valor col-ano col-customer-share text-right"></td>
                        <td class="col-valor col-ano col-valor-pretendido text-right"></td>
                        <td class="col-valor col-ano col-valor-projetado text-right col-separator" *ngIf="showProjetado"></td>

                        <!-- CS RAR -->
                        <td class="col-valor col-ano col-valor-realizado text-right"></td>
                        <td class="col-valor col-ano col-valor-pretendido-perc-evolucao text-right" *ngIf="isLancamentoValor()"></td>
                    </ng-template>
                </tr>

                <ng-template ngFor let-entityMes let-i="index" [ngForOf]="entityLancamento.meses">
                    <!-- Trimestre 1 -->
                    <ng-template [ngIf]="entityMes.mes === 1">
                        <tr class="trimestre">
                            <td class="col-periodicidade" (click)="toggleTrimestre(1, !entityLancamento.trimestre1CollapseShow)">
                                <i class="fas fa-plus" *ngIf="entityLancamento.trimestre1CollapseShow"></i>
                                <i class="fas fa-minus" *ngIf="!entityLancamento.trimestre1CollapseShow"></i>
                                Trimestre 1
                            </td>

                            <!--
                            <td class="col-status col-status-pretendido text-center"></td>
                            <td class="col-status col-status-projetado text-center"></td>
                            -->

                            <!-- Quantidade -->
                            <ng-template [ngIf]="entityLancamento.controleQuantidade">
                                <td class="col-quantidade col-ano-anterior2 col-quantidade-realizada col-separator text-right">
                                    {{entityLancamento.quantidadeRealizadaTrimestre1AnoAnterior2 | decimalFormat: 1:0:0}}
                                </td>
                                <td class="col-quantidade col-ano-anterior1 col-quantidade-pretendida text-right" *ngIf="isLancamentoQuantidade()">
                                    {{entityLancamento.quantidadePretendidaTrimestre1AnoAnterior1 | decimalFormat: 1:0:0}}
                                </td>
                                <td class="col-quantidade col-ano-anterior1 col-quantidade-realizada col-separator text-right">
                                    {{entityLancamento.quantidadeRealizadaTrimestre1AnoAnterior1 | decimalFormat: 1:0:0}}
                                </td>

                                <ng-template [ngIf]="isLancamentoQuantidade()">
                                    <td class="col-quantidade col-ano col-valor-unitario text-right" *ngIf="entityLancamento.solicitarPrecoMedio"></td>
                                    <td class="col-quantidade col-ano col-quantidade-potencial text-right" *ngIf="configAnaliseMercado?.solicitarPotencial">
                                        {{entityLancamento.quantidadePotencialTrimestre1 | decimalFormat: 1:0:0}}
                                    </td>
                                    <td class="col-quantidade col-ano col-quantidade-pretendida text-right">
                                        {{entityLancamento.quantidadePretendidaTrimestre1 | decimalFormat: 1:0:0}}
                                        <span *ngIf="configAnaliseMercado?.solicitarPotencial">
                                            | {{entityLancamento.quantidadePretendidaPercTrimestre1 | decimalFormat:1:0:0}}%
                                        </span>
                                    </td>
                                    <td class="col-quantidade col-ano col-valor-unitario-projetado text-right" *ngIf="showProjetado && entityLancamento.solicitarPrecoMedio"></td>
                                    <td class="col-quantidade col-ano col-quantidade-projetada text-right" *ngIf="showProjetado">
                                        {{entityLancamento.quantidadeProjetadaTrimestre1 | decimalFormat: 1:0:0}}
                                        <span *ngIf="configAnaliseMercado?.solicitarPotencial">
                                            | {{entityLancamento.quantidadeProjetadaPercTrimestre1 | decimalFormat: 1:0:0}}%
                                        </span>
                                    </td>
                                </ng-template>

                                <td class="col-quantidade col-ano col-quantidade-realizada text-right" [class.col-separator]="!isLancamentoQuantidade()">
                                    {{entityLancamento.quantidadeRealizadaTrimestre1 | decimalFormat: 1:0:0}}
                                    <!-- <span *ngIf="isLancamentoQuantidade()">
                                        | {{entityLancamento.quantidadeRealizadaPercPretendidaTrimestre1 | decimalFormat: 1:0:0}}%
                                    </span> -->
                                </td>
                                <td class="col-quantidade col-ano col-quantidade-pretendida-perc-evolucao col-separator text-right" *ngIf="isLancamentoQuantidade()">
                                    {{entityLancamento.quantidadePretendidaPercEvolucaoTrimestre1 | decimalFormat: 1:0:0}}%
                                </td>
                            </ng-template>

                            <!-- Peso -->
                            <ng-template [ngIf]="entityLancamento.controlePeso">
                                <td class="col-peso col-ano-anterior2 col-peso-realizado col-separator text-right">
                                    {{entityLancamento.pesoRealizadoTrimestre1AnoAnterior2 | decimalFormat: 1:0:0}}
                                </td>
                                <td class="col-peso col-ano-anterior1 col-peso-pretendido text-right" *ngIf="isLancamentoPeso()">
                                    {{entityLancamento.pesoPretendidoTrimestre1AnoAnterior1 | decimalFormat: 1:0:0}}
                                </td>
                                <td class="col-peso col-ano-anterior1 col-peso-realizado col-separator text-right">
                                    {{entityLancamento.pesoRealizadoTrimestre1AnoAnterior1 | decimalFormat: 1:0:0}}
                                </td>

                                <ng-template [ngIf]="isLancamentoPeso()">
                                    <td class="col-peso col-ano col-valor-unitario text-right" *ngIf="entityLancamento.solicitarPrecoMedio"></td>
                                    <td class="col-peso col-ano col-peso-potencial text-right" *ngIf="configAnaliseMercado?.solicitarPotencial">
                                        {{entityLancamento.pesoPotencialTrimestre1 | decimalFormat: 1:0:0}}
                                    </td>
                                    <td class="col-peso col-ano col-peso-pretendido text-right">
                                        {{entityLancamento.pesoPretendidoTrimestre1 | decimalFormat: 1:0:0}}
                                        <span *ngIf="configAnaliseMercado?.solicitarPotencial">
                                            | {{entityLancamento.pesoPretendidoPercTrimestre1 | decimalFormat: 1:0:0}}%
                                        </span>
                                    </td>
                                    <td class="col-peso col-ano col-valor-unitario-projetado text-right" *ngIf="showProjetado && entityLancamento.solicitarPrecoMedio"></td>
                                    <td class="col-peso col-ano col-peso-projetado text-right" *ngIf="showProjetado">
                                        {{entityLancamento.pesoProjetadoTrimestre1 | decimalFormat: 1:0:0}}
                                        <span *ngIf="configAnaliseMercado?.solicitarPotencial">
                                            | {{entityLancamento.pesoProjetadoPercTrimestre1 | decimalFormat: 1:0:0}}%
                                        </span>
                                    </td>
                                </ng-template>

                                <td class="col-peso col-ano col-peso-realizado text-right" [class.col-separator]="!isLancamentoPeso()">
                                    {{entityLancamento.pesoRealizadoTrimestre1 | decimalFormat: 1:0:0}}
                                    <!-- <span *ngIf="isLancamentoPeso()">
                                        | {{entityLancamento.pesoRealizadoPercPretendidoTrimestre1 | decimalFormat: 1:0:0}}%
                                    </span>                   -->
                                </td>
                                <td class="col-peso col-ano col-peso-pretendido-perc-evolucao col-separator text-right" *ngIf="isLancamentoPeso()">
                                    {{entityLancamento.pesoPretendidoPercEvolucaoTrimestre1 | decimalFormat: 1:0:0}}%
                                </td>
                            </ng-template>

                            <!-- Valor -->
                            <ng-template [ngIf]="entityLancamento.controleValor">
                                <!-- Ano Anterior 2 -->
                                <td class="col-valor col-ano-anterior2 col-valor-realizado col-separator text-right">
                                    {{entityLancamento.valorRealizadoTrimestre1AnoAnterior2 | decimalFormat: 1:0:0}}
                                </td>

                                <!-- Ano Anterior 1 -->
                                <td class="col-valor col-ano-anterior1 col-valor-realizado text-right">
                                    {{entityLancamento.valorRealizadoTrimestre1AnoAnterior1 | decimalFormat: 1:0:0}}
                                </td>
                                <td class="col-valor col-ano-anterior1 col-valor-pretendido col-separator text-right">
                                    {{entityLancamento.valorPretendidoTrimestre1AnoAnterior1 | decimalFormat: 1:0:0}}
                                </td>

                                <!-- Sell In Cliente -->
                                <td class="col-valor col-ano col-valor-potencial col-separator text-right" *ngIf="configAnaliseMercado?.solicitarPotencial && isLancamentoValor()">
                                    {{entityLancamento.valorPotencialTrimestre1 | decimalFormat: 1:0:0}}
                                </td>

                                <!-- CS RAP -->
                                <td class="col-valor col-ano col-customer-share text-right">
                                    <sgt-customer-share-indicador-badge
                                        [indicador]="entityLancamento.indicadorCustomerSharePretendidoTrimestre1"
                                        [perc]="entityLancamento.valorPretendidoPercTrimestre1"
                                        fontSize="8px"
                                        padding="4px">
                                    </sgt-customer-share-indicador-badge>
                                </td>
                                <td class="col-valor col-ano col-valor-pretendido text-right">
                                    {{entityLancamento.valorPretendidoTrimestre1 | decimalFormat: 1:0:0}}
                                </td>
                                <td class="col-valor col-ano col-valor-projetado col-separator text-right" *ngIf="showProjetado">
                                    {{entityLancamento.valorProjetadoTrimestre1 | decimalFormat: 1:0:0}}
                                    <span *ngIf="configAnaliseMercado?.solicitarPotencial">
                                        | {{entityLancamento.valorProjetadoPercTrimestre1 | decimalFormat: 1:0:0}}%
                                    </span>
                                </td>

                                <!-- CS RAR -->
                                <td class="col-valor col-ano col-valor-realizado text-right">
                                    {{entityLancamento.valorRealizadoTrimestre1 | decimalFormat: 1:0:0}}
                                    <!-- <span>
                                        | {{entityLancamento.valorRealizadoPercPretendidoTrimestre1 | decimalFormat: 1:0:0}}%
                                    </span> -->
                                </td>
                                <td class="col-valor col-ano col-valor-pretendido-perc-evolucao text-right" *ngIf="isLancamentoValor()">
                                    {{entityLancamento.valorPretendidoPercEvolucaoTrimestre1 | decimalFormat: 1:0:0}}%
                                </td>
                            </ng-template>
                        </tr>
                    </ng-template>

                    <!-- Trimestre 2 -->
                    <ng-template [ngIf]="entityMes.mes === 4">
                        <tr class="trimestre">
                            <td class="col-periodicidade" (click)="toggleTrimestre(2, !entityLancamento.trimestre2CollapseShow)">
                                <i class="fas fa-plus" *ngIf="entityLancamento.trimestre2CollapseShow"></i>
                                <i class="fas fa-minus" *ngIf="!entityLancamento.trimestre2CollapseShow"></i>
                                Trimestre 2
                            </td>

                            <!--
                            <td class="col-status col-status-pretendido text-center"></td>
                            <td class="col-status col-status-projetado text-center"></td>
                            -->

                            <!-- Quantidade -->
                            <ng-template [ngIf]="entityLancamento.controleQuantidade">
                                <td class="col-quantidade col-ano-anterior2 col-quantidade-realizada col-separator text-right">
                                    {{entityLancamento.quantidadeRealizadaTrimestre2AnoAnterior2 | decimalFormat: 1:0:0}}
                                </td>
                                <td class="col-quantidade col-ano-anterior1 col-quantidade-pretendida text-right" *ngIf="isLancamentoQuantidade()">
                                    {{entityLancamento.quantidadePretendidaTrimestre2AnoAnterior1 | decimalFormat: 1:0:0}}
                                </td>
                                <td class="col-quantidade col-ano-anterior1 col-quantidade-realizada col-separator text-right">
                                    {{entityLancamento.quantidadeRealizadaTrimestre2AnoAnterior1 | decimalFormat: 1:0:0}}
                                </td>

                                <ng-template [ngIf]="isLancamentoQuantidade()">
                                    <td class="col-quantidade col-ano col-valor-unitario text-right" *ngIf="entityLancamento.solicitarPrecoMedio"></td>
                                    <td class="col-quantidade col-ano col-quantidade-potencial text-right" *ngIf="configAnaliseMercado?.solicitarPotencial">
                                        {{entityLancamento.quantidadePotencialTrimestre2 | decimalFormat: 1:0:0}}
                                    </td>
                                    <td class="col-quantidade col-ano col-quantidade-pretendida text-right">
                                        {{entityLancamento.quantidadePretendidaTrimestre2 | decimalFormat: 1:0:0}}
                                        <span *ngIf="configAnaliseMercado?.solicitarPotencial">
                                            | {{entityLancamento.quantidadePretendidaPercTrimestre2 | decimalFormat: 1:0:0}}%
                                        </span>
                                    </td>
                                    <td class="col-quantidade col-ano col-valor-unitario-projetado text-right" *ngIf="showProjetado && entityLancamento.solicitarPrecoMedio"></td>
                                    <td class="col-quantidade col-ano col-quantidade-projetada text-right" *ngIf="showProjetado">
                                        {{entityLancamento.quantidadeProjetadaTrimestre2 | decimalFormat: 1:0:0}}
                                        <span *ngIf="configAnaliseMercado?.solicitarPotencial">
                                            | {{entityLancamento.quantidadeProjetadaPercTrimestre2 | decimalFormat: 1:0:0}}%
                                        </span>
                                    </td>
                                </ng-template>

                                <td class="col-quantidade col-ano col-quantidade-realizada text-right" [class.col-separator]="!isLancamentoQuantidade()">
                                    {{entityLancamento.quantidadeRealizadaTrimestre2 | decimalFormat: 1:0:0}}
                                    <!-- <span *ngIf="isLancamentoQuantidade()">
                                        | {{entityLancamento.quantidadeRealizadaPercPretendidaTrimestre2 | decimalFormat: 1:0:0}}%
                                    </span> -->
                                </td>
                                <td class="col-quantidade col-ano col-quantidade-pretendida-perc-evolucao col-separator text-right" *ngIf="isLancamentoQuantidade()">
                                    {{entityLancamento.quantidadePretendidaPercEvolucaoTrimestre2 | decimalFormat: 1:0:0}}%
                                </td>
                            </ng-template>

                            <!-- Peso -->
                            <ng-template [ngIf]="entityLancamento.controlePeso">
                                <td class="col-peso col-ano-anterior2 col-peso-realizado col-separator text-right">
                                    {{entityLancamento.pesoRealizadoTrimestre2AnoAnterior2 | decimalFormat: 1:0:0}}
                                </td>
                                <td class="col-peso col-ano-anterior1 col-peso-pretendido text-right" *ngIf="isLancamentoPeso()">
                                    {{entityLancamento.pesoPretendidoTrimestre2AnoAnterior1 | decimalFormat: 1:0:0}}
                                </td>
                                <td class="col-peso col-ano-anterior1 col-peso-realizado col-separator text-right">
                                    {{entityLancamento.pesoRealizadoTrimestre2AnoAnterior1 | decimalFormat: 1:0:0}}
                                </td>

                                <ng-template [ngIf]="isLancamentoPeso()">
                                    <td class="col-peso col-ano col-valor-unitario text-right" *ngIf="entityLancamento.solicitarPrecoMedio"></td>
                                    <td class="col-peso col-ano col-peso-potencial text-right" *ngIf="configAnaliseMercado?.solicitarPotencial">
                                        {{entityLancamento.pesoPotencialTrimestre2 | decimalFormat: 1:0:0}}
                                    </td>
                                    <td class="col-peso col-ano col-peso-pretendido text-right">
                                        {{entityLancamento.pesoPretendidoTrimestre2 | decimalFormat: 1:0:0}}
                                        <span *ngIf="configAnaliseMercado?.solicitarPotencial">
                                            | {{entityLancamento.pesoPretendidoPercTrimestre2 | decimalFormat: 1:0:0}}%
                                        </span>
                                    </td>
                                    <td class="col-peso col-ano col-valor-unitario-projetado text-right" *ngIf="showProjetado && entityLancamento.solicitarPrecoMedio"></td>
                                    <td class="col-peso col-ano col-peso-projetado text-right" *ngIf="showProjetado">
                                        {{entityLancamento.pesoProjetadoTrimestre2 | decimalFormat: 1:0:0}}
                                        <span *ngIf="configAnaliseMercado?.solicitarPotencial">
                                            | {{entityLancamento.pesoProjetadoPercTrimestre2 | decimalFormat: 1:0:0}}%
                                        </span>
                                    </td>
                                </ng-template>

                                <td class="col-peso col-ano col-peso-realizado text-right" [class.col-separator]="!isLancamentoPeso()">
                                    {{entityLancamento.pesoRealizadoTrimestre2 | decimalFormat: 1:0:0}}
                                    <!-- <span *ngIf="isLancamentoPeso()">
                                        | {{entityLancamento.pesoRealizadoPercPretendidoTrimestre2 | decimalFormat: 1:0:0}}%
                                    </span> -->
                                </td>
                                <td class="col-peso col-ano col-peso-pretendido-perc-evolucao col-separator text-right" *ngIf="isLancamentoPeso()">
                                    {{entityLancamento.pesoPretendidoPercEvolucaoTrimestre2 | decimalFormat: 1:0:0}}%
                                </td>
                            </ng-template>

                            <!-- Valor -->
                            <ng-template [ngIf]="entityLancamento.controleValor">
                                <!-- Ano Anterior 2 -->
                                <td class="col-valor col-ano-anterior2 col-valor-realizado col-separator text-right">
                                    {{entityLancamento.valorRealizadoTrimestre2AnoAnterior2 | decimalFormat: 1:0:0}}
                                </td>

                                <!-- Ano Anterior 1 -->
                                <td class="col-valor col-ano-anterior1 col-valor-realizado text-right">
                                    {{entityLancamento.valorRealizadoTrimestre2AnoAnterior1 | decimalFormat: 1:0:0}}
                                </td>
                                <td class="col-valor col-ano-anterior1 col-valor-pretendido col-separator text-right">
                                    {{entityLancamento.valorPretendidoTrimestre2AnoAnterior1 | decimalFormat: 1:0:0}}
                                </td>

                                <!-- Sell In Cliente -->
                                <td class="col-valor col-ano col-valor-potencial col-separator text-right" *ngIf="configAnaliseMercado?.solicitarPotencial && isLancamentoValor()">
                                    {{entityLancamento.valorPotencialTrimestre2 | decimalFormat: 1:0:0}}
                                </td>

                                <!-- CS RAP -->
                                <td class="col-valor col-ano col-customer-share text-right">
                                    <sgt-customer-share-indicador-badge
                                        [indicador]="entityLancamento.indicadorCustomerSharePretendidoTrimestre2"
                                        [perc]="entityLancamento.valorPretendidoPercTrimestre2"
                                        fontSize="8px"
                                        padding="4px">
                                    </sgt-customer-share-indicador-badge>
                                </td>
                                <td class="col-valor col-ano col-valor-pretendido text-right">
                                    {{entityLancamento.valorPretendidoTrimestre2 | decimalFormat: 1:0:0}}
                                </td>
                                <td class="col-valor col-ano col-valor-projetado col-separator text-right" *ngIf="showProjetado">
                                    {{entityLancamento.valorProjetadoTrimestre2 | decimalFormat: 1:0:0}}
                                    <span *ngIf="configAnaliseMercado?.solicitarPotencial">
                                        | {{entityLancamento.valorProjetadoPercTrimestre2 | decimalFormat: 1:0:0}}%
                                    </span>
                                </td>

                                <!-- CS RAR -->
                                <td class="col-valor col-ano col-valor-realizado text-right">
                                    {{entityLancamento.valorRealizadoTrimestre2 | decimalFormat: 1:0:0}}
                                    <!-- <span>
                                        | {{entityLancamento.valorRealizadoPercPretendidoTrimestre2 | decimalFormat: 1:0:0}}%
                                    </span> -->
                                </td>
                                <td class="col-valor col-ano col-valor-pretendido-perc-evolucao text-right" *ngIf="isLancamentoValor()">
                                    {{entityLancamento.valorPretendidoPercEvolucaoTrimestre2 | decimalFormat: 1:0:0}}%
                                </td>
                            </ng-template>
                        </tr>
                    </ng-template>

                    <!-- Trimestre 3 -->
                    <ng-template [ngIf]="entityMes.mes === 7">
                        <tr class="trimestre">
                            <td class="col-periodicidade" (click)="toggleTrimestre(3, !entityLancamento.trimestre3CollapseShow)">
                                <i class="fas fa-plus" *ngIf="entityLancamento.trimestre3CollapseShow"></i>
                                <i class="fas fa-minus" *ngIf="!entityLancamento.trimestre3CollapseShow"></i>
                                Trimestre 3
                            </td>

                            <!--
                            <td class="col-status col-status-pretendido text-center"></td>
                            <td class="col-status col-status-projetado text-center"></td>
                            -->

                            <!-- Quantidade -->
                            <ng-template [ngIf]="entityLancamento.controleQuantidade">
                                <td class="col-quantidade col-ano-anterior2 col-quantidade-realizada col-separator text-right">
                                    {{entityLancamento.quantidadeRealizadaTrimestre3AnoAnterior2 | decimalFormat: 1:0:0}}
                                </td>
                                <td class="col-quantidade col-ano-anterior1 col-quantidade-pretendida text-right" *ngIf="isLancamentoQuantidade()">
                                    {{entityLancamento.quantidadePretendidaTrimestre3AnoAnterior1 | decimalFormat: 1:0:0}}
                                </td>
                                <td class="col-quantidade col-ano-anterior1 col-quantidade-realizada col-separator text-right">
                                    {{entityLancamento.quantidadeRealizadaTrimestre3AnoAnterior1 | decimalFormat: 1:0:0}}
                                </td>

                                <ng-template [ngIf]="isLancamentoQuantidade()">
                                    <td class="col-quantidade col-ano col-valor-unitario text-right" *ngIf="entityLancamento.solicitarPrecoMedio"></td>
                                    <td class="col-quantidade col-ano col-quantidade-potencial text-right" *ngIf="configAnaliseMercado?.solicitarPotencial">
                                        {{entityLancamento.quantidadePotencialTrimestre3 | decimalFormat: 1:0:0}}
                                    </td>
                                    <td class="col-quantidade col-ano col-quantidade-pretendida text-right">
                                        {{entityLancamento.quantidadePretendidaTrimestre3 | decimalFormat: 1:0:0}}
                                        <span *ngIf="configAnaliseMercado?.solicitarPotencial">
                                            | {{entityLancamento.quantidadePretendidaPercTrimestre3 | decimalFormat: 1:0:0}}%
                                        </span>
                                    </td>
                                    <td class="col-quantidade col-ano col-valor-unitario-projetado text-right" *ngIf="showProjetado && entityLancamento.solicitarPrecoMedio"></td>
                                    <td class="col-quantidade col-ano col-quantidade-projetada text-right" *ngIf="showProjetado">
                                        {{entityLancamento.quantidadeProjetadaTrimestre3 | decimalFormat: 1:0:0}}
                                        <span *ngIf="configAnaliseMercado?.solicitarPotencial">
                                            | {{entityLancamento.quantidadeProjetadaPercTrimestre3 | decimalFormat: 1:0:0}}%
                                        </span>
                                    </td>
                                </ng-template>

                                <td class="col-quantidade col-ano col-quantidade-realizada text-right" [class.col-separator]="!isLancamentoQuantidade()">
                                    {{entityLancamento.quantidadeRealizadaTrimestre3 | decimalFormat: 1:0:0}}
                                    <!-- <span *ngIf="isLancamentoQuantidade()">
                                        | {{entityLancamento.quantidadeRealizadaPercPretendidaTrimestre3 | decimalFormat: 1:0:0}}%
                                    </span> -->
                                </td>
                                <td class="col-quantidade col-ano col-quantidade-pretendida-perc-evolucao col-separator text-right" *ngIf="isLancamentoQuantidade()">
                                    {{entityLancamento.quantidadePretendidaPercEvolucaoTrimestre3 | decimalFormat: 1:0:0}}%
                                </td>
                            </ng-template>

                            <!-- Peso -->
                            <ng-template [ngIf]="entityLancamento.controlePeso">
                                <td class="col-peso col-ano-anterior2 col-peso-realizado col-separator text-right">
                                    {{entityLancamento.pesoRealizadoTrimestre3AnoAnterior2 | decimalFormat: 1:0:0}}
                                </td>
                                <td class="col-peso col-ano-anterior1 col-peso-pretendido text-right" *ngIf="isLancamentoPeso()">
                                    {{entityLancamento.pesoPretendidoTrimestre3AnoAnterior1 | decimalFormat: 1:0:0}}
                                </td>
                                <td class="col-peso col-ano-anterior1 col-peso-realizado col-separator text-right">
                                    {{entityLancamento.pesoRealizadoTrimestre3AnoAnterior1 | decimalFormat: 1:0:0}}
                                </td>

                                <ng-template [ngIf]="isLancamentoPeso()">
                                    <td class="col-peso col-ano col-valor-unitario text-right" *ngIf="entityLancamento.solicitarPrecoMedio"></td>
                                    <td class="col-peso col-ano col-peso-potencial text-right" *ngIf="configAnaliseMercado?.solicitarPotencial">
                                        {{entityLancamento.pesoPotencialTrimestre3 | decimalFormat: 1:0:0}}
                                    </td>
                                    <td class="col-peso col-ano col-peso-pretendido text-right">
                                        {{entityLancamento.pesoPretendidoTrimestre3 | decimalFormat: 1:0:0}}
                                        <span *ngIf="configAnaliseMercado?.solicitarPotencial">
                                            | {{entityLancamento.pesoPretendidoPercTrimestre3 | decimalFormat: 1:0:0}}%
                                        </span>
                                    </td>
                                    <td class="col-peso col-ano col-valor-unitario-projetado text-right" *ngIf="showProjetado && entityLancamento.solicitarPrecoMedio"></td>
                                    <td class="col-peso col-ano col-peso-projetado text-right" *ngIf="showProjetado">
                                        {{entityLancamento.pesoProjetadoTrimestre3 | decimalFormat: 1:0:0}}
                                        <span *ngIf="configAnaliseMercado?.solicitarPotencial">
                                            | {{entityLancamento.pesoProjetadoPercTrimestre3 | decimalFormat: 1:0:0}}%
                                        </span>
                                    </td>
                                </ng-template>

                                <td class="col-peso col-ano col-peso-realizado text-right" [class.col-separator]="!isLancamentoPeso()">
                                    {{entityLancamento.pesoRealizadoTrimestre3 | decimalFormat: 1:0:0}}
                                    <!-- <span *ngIf="isLancamentoPeso()">
                                        | {{entityLancamento.pesoRealizadoPercPretendidoTrimestre3 | decimalFormat: 1:0:0}}%
                                    </span> -->
                                </td>
                                <td class="col-peso col-ano col-peso-pretendido-perc-evolucao col-separator text-right" *ngIf="isLancamentoPeso()">
                                    {{entityLancamento.pesoPretendidoPercEvolucaoTrimestre3 | decimalFormat: 1:0:0}}%
                                </td>
                            </ng-template>

                            <!-- Valor -->
                            <ng-template [ngIf]="entityLancamento.controleValor">
                                <!-- Ano Anterior 2 -->
                                <td class="col-valor col-ano-anterior2 col-valor-realizado col-separator text-right">
                                    {{entityLancamento.valorRealizadoTrimestre3AnoAnterior2 | decimalFormat: 1:0:0}}
                                </td>

                                <!-- Ano Anterior 1 -->
                                <td class="col-valor col-ano-anterior1 col-valor-realizado  text-right">
                                    {{entityLancamento.valorRealizadoTrimestre3AnoAnterior1 | decimalFormat: 1:0:0}}
                                </td>
                                <td class="col-valor col-ano-anterior1 col-valor-pretendido col-separator text-right">
                                    {{entityLancamento.valorPretendidoTrimestre3AnoAnterior1 | decimalFormat: 1:0:0}}
                                </td>

                                <!-- Sell In Cliente -->
                                <td class="col-valor col-ano col-valor-potencial col-separator text-right" *ngIf="configAnaliseMercado?.solicitarPotencial && isLancamentoValor()">
                                    {{entityLancamento.valorPotencialTrimestre3 | decimalFormat: 1:0:0}}
                                </td>

                                <!-- CS RAP -->
                                <td class="col-valor col-ano col-customer-share text-right">
                                    <sgt-customer-share-indicador-badge
                                        [indicador]="entityLancamento.indicadorCustomerSharePretendidoTrimestre3"
                                        [perc]="entityLancamento.valorPretendidoPercTrimestre3"
                                        fontSize="8px"
                                        padding="4px">
                                    </sgt-customer-share-indicador-badge>
                                </td>
                                <td class="col-valor col-ano col-valor-pretendido text-right">
                                    {{entityLancamento.valorPretendidoTrimestre3 | decimalFormat: 1:0:0}}
                                </td>
                                <td class="col-valor col-ano col-valor-projetado col-separator text-right" *ngIf="showProjetado">
                                    {{entityLancamento.valorProjetadoTrimestre3 | decimalFormat: 1:0:0}}
                                    <span *ngIf="configAnaliseMercado?.solicitarPotencial">
                                        | {{entityLancamento.valorProjetadoPercTrimestre3 | decimalFormat: 1:0:0}}%
                                    </span>
                                </td>

                                <!-- CS RAR -->
                                <td class="col-valor col-ano col-valor-realizado text-right">
                                    {{entityLancamento.valorRealizadoTrimestre3 | decimalFormat: 1:0:0}}
                                    <!-- <span>
                                        | {{entityLancamento.valorRealizadoPercPretendidoTrimestre3 | decimalFormat: 1:0:0}}%
                                    </span> -->
                                </td>
                                <td class="col-valor col-ano col-valor-pretendido-perc-evolucao text-right" *ngIf="isLancamentoValor()">
                                    {{entityLancamento.valorPretendidoPercEvolucaoTrimestre3 | decimalFormat: 1:0:0}}%
                                </td>
                            </ng-template>
                        </tr>
                    </ng-template>

                    <!-- Trimestre 4 -->
                    <ng-template [ngIf]="entityMes.mes === 10">
                        <tr class="trimestre">
                            <td class="col-periodicidade" (click)="toggleTrimestre(4, !entityLancamento.trimestre4CollapseShow)">
                                <i class="fas fa-plus" *ngIf="entityLancamento.trimestre4CollapseShow"></i>
                                <i class="fas fa-minus" *ngIf="!entityLancamento.trimestre4CollapseShow"></i>
                                Trimestre 4
                            </td>

                            <!--
                            <td class="col-status col-status-pretendido text-center"></td>
                            <td class="col-status col-status-projetado text-center"></td>
                            -->

                            <!-- Quantidade -->
                            <ng-template [ngIf]="entityLancamento.controleQuantidade">
                                <td class="col-quantidade col-ano-anterior2 col-quantidade-realizada col-separator text-right">
                                    {{entityLancamento.quantidadeRealizadaTrimestre4AnoAnterior2 | decimalFormat: 1:0:0}}
                                </td>
                                <td class="col-quantidade col-ano-anterior1 col-quantidade-pretendida text-right" *ngIf="isLancamentoQuantidade()">
                                    {{entityLancamento.quantidadePretendidaTrimestre4AnoAnterior1 | decimalFormat: 1:0:0}}
                                </td>
                                <td class="col-quantidade col-ano-anterior1 col-quantidade-realizada col-separator text-right">
                                    {{entityLancamento.quantidadeRealizadaTrimestre4AnoAnterior1 | decimalFormat: 1:0:0}}
                                </td>

                                <ng-template [ngIf]="isLancamentoQuantidade()">
                                    <td class="col-quantidade col-ano col-valor-unitario text-right" *ngIf="entityLancamento.solicitarPrecoMedio"></td>
                                    <td class="col-quantidade col-ano col-quantidade-potencial text-right" *ngIf="configAnaliseMercado?.solicitarPotencial">
                                        {{entityLancamento.quantidadePotencialTrimestre4 | decimalFormat: 1:0:0}}
                                    </td>
                                    <td class="col-quantidade col-ano col-quantidade-pretendida text-right">
                                        {{entityLancamento.quantidadePretendidaTrimestre4 | decimalFormat: 1:0:0}}
                                        <span *ngIf="configAnaliseMercado?.solicitarPotencial">
                                            | {{entityLancamento.quantidadePretendidaPercTrimestre4 | decimalFormat: 1:0:0}}%
                                        </span>
                                    </td>
                                    <td class="col-quantidade col-ano col-valor-unitario-projetado text-right" *ngIf="showProjetado && entityLancamento.solicitarPrecoMedio"></td>
                                    <td class="col-quantidade col-ano col-quantidade-projetada text-right" *ngIf="showProjetado">
                                        {{entityLancamento.quantidadeProjetadaTrimestre4 | decimalFormat: 1:0:0}}
                                        <span *ngIf="configAnaliseMercado?.solicitarPotencial">
                                            | {{entityLancamento.quantidadeProjetadaPercTrimestre4 | decimalFormat: 1:0:0}}%
                                        </span>
                                    </td>
                                </ng-template>

                                <td class="col-quantidade col-ano col-quantidade-realizada text-right" [class.col-separator]="!isLancamentoQuantidade()">
                                    {{entityLancamento.quantidadeRealizadaTrimestre4 | decimalFormat: 1:0:0}}
                                    <!-- <span *ngIf="isLancamentoQuantidade()">
                                        | {{entityLancamento.quantidadeRealizadaPercPretendidaTrimestre4 | decimalFormat: 1:0:0}}%
                                    </span> -->
                                </td>
                                <td class="col-quantidade col-ano col-quantidade-pretendida-perc-evolucao col-separator text-right" *ngIf="isLancamentoQuantidade()">
                                    {{entityLancamento.quantidadePretendidaPercEvolucaoTrimestre4 | decimalFormat: 1:0:0}}%
                                </td>
                            </ng-template>

                            <!-- Peso -->
                            <ng-template [ngIf]="entityLancamento.controlePeso">
                                <td class="col-peso col-ano-anterior2 col-peso-realizado col-separator text-right">
                                    {{entityLancamento.pesoRealizadoTrimestre4AnoAnterior2 | decimalFormat: 1:0:0}}
                                </td>
                                <td class="col-peso col-ano-anterior1 col-peso-pretendido text-right" *ngIf="isLancamentoPeso()">
                                    {{entityLancamento.pesoPretendidoTrimestre4AnoAnterior1 | decimalFormat: 1:0:0}}
                                </td>
                                <td class="col-peso col-ano-anterior1 col-peso-realizado col-separator text-right">
                                    {{entityLancamento.pesoRealizadoTrimestre4AnoAnterior1 | decimalFormat: 1:0:0}}
                                </td>

                                <ng-template [ngIf]="isLancamentoPeso()">
                                    <td class="col-peso col-ano col-valor-unitario text-right" *ngIf="entityLancamento.solicitarPrecoMedio"></td>
                                    <td class="col-peso col-ano col-peso-potencial text-right" *ngIf="configAnaliseMercado?.solicitarPotencial">
                                        {{entityLancamento.pesoPotencialTrimestre4 | decimalFormat: 1:0:0}}
                                    </td>
                                    <td class="col-peso col-ano col-peso-pretendido text-right">
                                        {{entityLancamento.pesoPretendidoTrimestre4 | decimalFormat: 1:0:0}}
                                        <span *ngIf="configAnaliseMercado?.solicitarPotencial">
                                            | {{entityLancamento.pesoPretendidoPercTrimestre4 | decimalFormat: 1:0:0}}%
                                        </span>
                                    </td>
                                    <td class="col-peso col-ano col-valor-unitario-projetado text-right" *ngIf="showProjetado && entityLancamento.solicitarPrecoMedio"></td>
                                    <td class="col-peso col-ano col-peso-projetado text-right" *ngIf="showProjetado">
                                        {{entityLancamento.pesoProjetadoTrimestre4 | decimalFormat: 1:0:0}}
                                        <span *ngIf="configAnaliseMercado?.solicitarPotencial">
                                            | {{entityLancamento.pesoProjetadoPercTrimestre4 | decimalFormat: 1:0:0}}%
                                        </span>
                                    </td>
                                </ng-template>

                                <td class="col-peso col-ano col-peso-realizado text-right" [class.col-separator]="!isLancamentoPeso()">
                                    {{entityLancamento.pesoRealizadoTrimestre4 | decimalFormat: 1:0:0}}
                                    <!-- <span *ngIf="isLancamentoPeso()">
                                        | {{entityLancamento.pesoRealizadoPercPretendidoTrimestre4 | decimalFormat: 1:0:0}}%
                                    </span> -->
                                </td>
                                <td class="col-peso col-ano col-peso-pretendido-perc-evolucao col-separator text-right" *ngIf="isLancamentoPeso()">
                                    {{entityLancamento.pesoPretendidoPercEvolucaoTrimestre4 | decimalFormat: 1:0:0}}%
                                </td>
                            </ng-template>

                            <!-- Valor -->
                            <ng-template [ngIf]="entityLancamento.controleValor">
                                <!-- Ano Anterior 2 -->
                                <td class="col-valor col-ano-anterior2 col-valor-realizado col-separator text-right">
                                    {{entityLancamento.valorRealizadoTrimestre4AnoAnterior2 | decimalFormat: 1:0:0}}
                                </td>

                                <!-- Ano Anterior 1 -->
                                <td class="col-valor col-ano-anterior1 col-valor-realizado text-right">
                                    {{entityLancamento.valorRealizadoTrimestre4AnoAnterior1 | decimalFormat: 1:0:0}}
                                </td>
                                <td class="col-valor col-ano-anterior1 col-valor-pretendido col-separator text-right">
                                    {{entityLancamento.valorPretendidoTrimestre4AnoAnterior1 | decimalFormat: 1:0:0}}
                                </td>

                                <!-- Sell In Cliente -->
                                <td class="col-valor col-ano col-valor-potencial col-separator text-right" *ngIf="configAnaliseMercado?.solicitarPotencial && isLancamentoValor()">
                                    {{entityLancamento.valorPotencialTrimestre4 | decimalFormat: 1:0:0}}
                                </td>

                                <!-- CS RAP -->
                                <td class="col-valor col-ano col-customer-share text-right">
                                    <sgt-customer-share-indicador-badge
                                        [indicador]="entityLancamento.indicadorCustomerSharePretendidoTrimestre4"
                                        [perc]="entityLancamento.valorPretendidoPercTrimestre4"
                                        fontSize="8px"
                                        padding="4px">
                                    </sgt-customer-share-indicador-badge>
                                </td>
                                <td class="col-valor col-ano col-valor-pretendido text-right">
                                    {{entityLancamento.valorPretendidoTrimestre4 | decimalFormat: 1:0:0}}
                                </td>
                                <td class="col-valor col-ano col-valor-projetado col-separator text-right" *ngIf="showProjetado">
                                    {{entityLancamento.valorProjetadoTrimestre4 | decimalFormat: 1:0:0}}
                                    <span *ngIf="configAnaliseMercado?.solicitarPotencial">
                                        | {{entityLancamento.valorProjetadoPercTrimestre4 | decimalFormat: 1:0:0}}%
                                    </span>
                                </td>

                                <!-- CS RAR -->
                                <td class="col-valor col-ano col-valor-realizado text-right">
                                    {{entityLancamento.valorRealizadoTrimestre4 | decimalFormat: 1:0:0}}
                                    <!-- <span>
                                        | {{entityLancamento.valorRealizadoPercPretendidoTrimestre4 | decimalFormat: 1:0:0}}%
                                    </span> -->
                                </td>
                                <td class="col-valor col-ano col-valor-pretendido-perc-evolucao text-right" *ngIf="isLancamentoValor()">
                                    {{entityLancamento.valorPretendidoPercEvolucaoTrimestre4 | decimalFormat: 1:0:0}}%
                                </td>
                            </ng-template>
                        </tr>
                    </ng-template>

                    <!-- Meses -->
                    <tr class="mes trimestre_{{entityMes.trimestre}}">
                        <td class="col-periodicidade">{{entityMes.mes | mes}}</td>

                        <!--
                        <td class="col-status col-status-pretendido text-center">
                            <sgt-cliente-analise-mercado-status-pretendido-badge-pill
                                [statusPretendido]="entityMes.statusPretendido"
                                title="{{entityMes.statusPretendido | clienteAnaliseMercadoStatusPretendido}} em {{entityMes.mes | mes}}">
                            </sgt-cliente-analise-mercado-status-pretendido-badge-pill>
                        </td>
                        <td class="col-status col-status-projetado text-center">
                            <sgt-cliente-analise-mercado-status-projetado-badge-pill
                                [statusProjetado]="entityMes.statusProjetado"
                                title="{{entityMes.statusProjetado | clienteAnaliseMercadoStatusProjetado: entityMes.idEtapaNegociacaoProjecao:entityMes.nomeEtapaNegociacaoProjecao}} em {{entityMes.mes | mes}}">
                            </sgt-cliente-analise-mercado-status-projetado-badge-pill>
                        </td>
                        -->

                        <!-- Quantidade -->
                        <ng-template [ngIf]="entityLancamento.controleQuantidade">
                            <td class="col-quantidade col-ano-anterior2 col-quantidade-realizada col-separator text-right">
                                {{entityMes.quantidadeRealizadaAnoAnterior2 | decimalFormat: 1:0:0}}
                            </td>
                            <td class="col-quantidade col-ano-anterior1 col-quantidade-pretendida text-right" *ngIf="isLancamentoQuantidade()">
                                {{entityMes.quantidadePretendidaAnoAnterior1 | decimalFormat: 1:0:0}}
                            </td>
                            <td class="col-quantidade col-ano-anterior1 col-quantidade-realizada col-separator text-right">
                                {{entityMes.quantidadeRealizadaAnoAnterior1 | decimalFormat: 1:0:0}}
                            </td>

                            <ng-template [ngIf]="isLancamentoQuantidade()">
                                <td class="col-quantidade col-ano col-valor-unitario text-right" *ngIf="entityLancamento.solicitarPrecoMedio">
                                    <ng-template [ngIf]="canEditLancamentoQuantidadeMensal()">
                                        <sgt-decimal2 [ngModel]="entityMes.quantidadePretendidaValorUnitario" name="quantidadePretendidaValorUnitario_{{i}}" id="quantidadePretendidaValorUnitario_{{i}}"
                                            #quantidadePretendidaValorUnitario="ngModel" [ngControl]="quantidadePretendidaValorUnitario" #quantidadePretetendidaValorUnitarioDecimalMes
                                            (ngModelChange)="onChangeQuantidadePretendidaValorUnitarioMes(entityMes, $event)" [required]="isQuantidadePretendidaValorUnitarioMesRequired(entityMes)"
                                            sgtTableTrActive>
                                        </sgt-decimal2>
                                    </ng-template>
                                    <ng-template [ngIf]="!canEditLancamentoQuantidadeMensal()">
                                        {{entityMes.quantidadePretendidaValorUnitario | decimalFormat: 1:2:2}}
                                    </ng-template>
                                </td>
                                <td class="col-quantidade col-ano col-quantidade-potencial text-right" *ngIf="configAnaliseMercado?.solicitarPotencial">
                                    <sgt-decimal2 [ngModel]="entityMes.quantidadePotencial" name="quantidadePotencial_{{i}}" id="quantidadePotencial_{{i}}"
                                        #quantidadePotencial="ngModel" [ngControl]="quantidadePotencial" [digits]="0"
                                        (ngModelChange)="onChangeQuantidadePotencialMes(entityMes, $event)"
                                        [disabled]="!canEditLancamentoQuantidadeMensal()" [readonly]="!canEditLancamentoQuantidadeMensal()"
                                        sgtTableTrActive>
                                    </sgt-decimal2>
                                </td>
                                <td class="col-quantidade col-ano col-quantidade-pretendida text-right">
                                    <div class="input-group">
                                        <sgt-decimal2 [ngModel]="entityMes.quantidadePretendida" name="quantidadePretendida_{{i}}" id="quantidadePretendida_{{i}}"
                                            #quantidadePretendida="ngModel" [ngControl]="quantidadePretendida" [digits]="0"
                                            (ngModelChange)="onChangeQuantidadePretendidaMes(entityMes, $event)"
                                            [disabled]="!canEditLancamentoQuantidadeMensal()" [readonly]="!canEditLancamentoQuantidadeMensal()"
                                            sgtTableTrActive>
                                        </sgt-decimal2>

                                        <ng-template [ngIf]="configAnaliseMercado?.solicitarPotencial">
                                            <div class="input-group-append">
                                                <span class="input-group-text">
                                                    |
                                                </span>
                                            </div>
                                            <sgt-decimal2 [ngModel]="entityMes.quantidadePretendidaPerc"
                                                class="input-perc" name="quantidadePretendidaPerc_{{i}}" id="quantidadePretendidaPerc_{{i}}"
                                                #quantidadePretendidaPerc="ngModel" [ngControl]="quantidadePretendidaPerc" [digits]="0"
                                                (ngModelChange)="onChangeQuantidadePretendidaPercMes(entityMes, $event)"
                                                [disabled]="!canEditLancamentoQuantidadeMensal()" [readonly]="!canEditLancamentoQuantidadeMensal()"
                                                sgtTableTrActive>
                                            </sgt-decimal2>
                                        </ng-template>
                                        <div class="input-group-append" *ngIf="configAnaliseMercado?.solicitarPotencial">
                                            <span class="input-group-text">
                                                %
                                            </span>
                                        </div>
                                    </div>
                                </td>
                                <td class="col-quantidade col-ano col-valor-unitario-projetado text-right" *ngIf="showProjetado && entityLancamento.solicitarPrecoMedio">
                                    {{entityMes.quantidadeProjetadaValorUnitario | decimalFormat: 1:2:2}}
                                </td>
                                <td class="col-quantidade col-ano col-quantidade-projetada text-right" *ngIf="showProjetado">
                                    <div class="input-group">
                                        <!-- <sgt-decimal2 [ngModel]="entityMes.quantidadeProjetada" name="quantidadeProjetada_{{i}}" id="quantidadeProjetada_{{i}}"
                                            #quantidadeProjetada="ngModel" [ngControl]="quantidadeProjetada" [digits]="0"
                                            (ngModelChange)="onChangeQuantidadeProjetadaMes(entityMes, $event)"
                                            sgtTableTrActive>
                                        </sgt-decimal2>  -->
                                        <input type="text"
                                            value="{{entityMes.quantidadeProjetada | decimalFormat: 1:0:0}}"
                                            class="form-control text-right" disabled="disabled" readonly="readonly">

                                        <div class="input-group-append" *ngIf="configAnaliseMercado?.solicitarPotencial">
                                            <span class="input-group-text">
                                                {{entityMes.quantidadeProjetadaPerc | decimalFormat: 1:0:0}}%
                                            </span>
                                        </div>
                                    </div>
                                </td>
                            </ng-template>

                            <td class="col-quantidade col-ano col-quantidade-realizada text-right" [class.col-separator]="!isLancamentoQuantidade()">
                                {{entityMes.quantidadeRealizada | decimalFormat: 1:0:0}}
                                <!-- <span *ngIf="isLancamentoQuantidade()">
                                    | {{entityMes.quantidadeRealizadaPercPretendida | decimalFormat: 1:0:0}}%
                                </span> -->
                            </td>
                            <td class="col-quantidade col-ano col-quantidade-pretendida-perc-evolucao col-separator text-right" *ngIf="isLancamentoQuantidade()">
                                {{entityMes.quantidadePretendidaPercEvolucao | decimalFormat: 1:0:0}}%
                            </td>
                        </ng-template>

                        <!-- Peso -->
                        <ng-template [ngIf]="entityLancamento.controlePeso">
                            <td class="col-peso col-ano-anterior2 col-peso-realizado col-separator text-right">
                                {{entityMes.pesoRealizadoAnoAnterior2 | decimalFormat: 1:0:0}}
                            </td>
                            <td class="col-peso col-ano-anterior1 col-peso-pretendido text-right" *ngIf="isLancamentoPeso()">
                                {{entityMes.pesoPretendidoAnoAnterior1 | decimalFormat: 1:0:0}}
                            </td>
                            <td class="col-peso col-ano-anterior1 col-peso-realizado col-separator text-right">
                                {{entityMes.pesoRealizadoAnoAnterior1 | decimalFormat: 1:0:0}}
                            </td>

                            <ng-template [ngIf]="isLancamentoPeso()">
                                <td class="col-peso col-ano col-valor-unitario text-right" *ngIf="entityLancamento.solicitarPrecoMedio">
                                    <ng-template [ngIf]="canEditLancamentoPesoMensal()">
                                        <sgt-decimal2 [ngModel]="entityMes.pesoPretendidoValorUnitario" name="pesoPretendidoValorUnitario_{{i}}" id="pesoPretendidoValorUnitario_{{i}}"
                                            #pesoPretendidoValorUnitario="ngModel" [ngControl]="pesoPretendidoValorUnitario" #pesoPretendidoValorUnitarioDecimalMes
                                            (ngModelChange)="onChangePesoPretendidoValorUnitarioMes(entityMes, $event)" [required]="isPesoPretendidoValorUnitarioMesRequired(entityMes)"
                                            sgtTableTrActive>
                                        </sgt-decimal2>
                                    </ng-template>
                                    <ng-template [ngIf]="!canEditLancamentoPesoMensal()">
                                        {{entityMes.pesoPretendidoValorUnitario | decimalFormat: 1:2:2}}
                                    </ng-template>
                                </td>
                                <td class="col-peso col-ano col-peso-potencial text-right" *ngIf="configAnaliseMercado?.solicitarPotencial">
                                    <sgt-decimal2 [ngModel]="entityMes.pesoPotencial" name="pesoPotencial_{{i}}" id="pesoPotencial_{{i}}"
                                        #pesoPotencial="ngModel" [ngControl]="pesoPotencial" [digits]="0"
                                        (ngModelChange)="onChangePesoPotencialMes(entityMes, $event)"
                                        [disabled]="!canEditLancamentoPesoMensal()" [readonly]="!canEditLancamentoPesoMensal()"
                                        sgtTableTrActive>
                                    </sgt-decimal2>
                                </td>
                                <td class="col-peso col-ano col-peso-pretendido text-right">
                                    <div class="input-group">
                                        <sgt-decimal2 [ngModel]="entityMes.pesoPretendido" name="pesoPretendido_{{i}}" id="pesoPretendido_{{i}}"
                                            #pesoPretendido="ngModel" [ngControl]="pesoPretendido" [digits]="0"
                                            (ngModelChange)="onChangePesoPretendidoMes(entityMes, $event)"
                                            [disabled]="!canEditLancamentoPesoMensal()" [readonly]="!canEditLancamentoPesoMensal()"
                                            sgtTableTrActive>
                                        </sgt-decimal2>

                                        <ng-template [ngIf]="configAnaliseMercado?.solicitarPotencial">
                                            <div class="input-group-append">
                                                <span class="input-group-text">
                                                    |
                                                </span>
                                            </div>
                                            <sgt-decimal2 [ngModel]="entityMes.pesoPretendidoPerc"
                                                class="input-perc" name="pesoPretendidoPerc_{{i}}" id="pesoPretendidoPerc_{{i}}"
                                                #pesoPretendidoPerc="ngModel" [ngControl]="pesoPretendidoPerc" [digits]="0"
                                                (ngModelChange)="onChangePesoPretendidoPercMes(entityMes, $event)"
                                                [disabled]="!canEditLancamentoPesoMensal()" [readonly]="!canEditLancamentoPesoMensal()"
                                                sgtTableTrActive>
                                            </sgt-decimal2>
                                            <div class="input-group-append">
                                                <span class="input-group-text">
                                                    %
                                                </span>
                                            </div>
                                        </ng-template>
                                    </div>
                                </td>
                                <td class="col-peso col-ano col-valor-unitario-projetado text-right" *ngIf="showProjetado && entityLancamento.solicitarPrecoMedio">
                                    {{entityMes.pesoProjetadoValorUnitario | decimalFormat: 1:2:2}}
                                </td>
                                <td class="col-peso col-ano col-peso-projetado text-right" *ngIf="showProjetado">
                                    <div class="input-group">
                                        <!-- <sgt-decimal2 [ngModel]="entityMes.pesoProjetado" name="pesoProjetado_{{i}}" id="pesoProjetado_{{i}}"
                                            #pesoProjetado="ngModel" [ngControl]="pesoProjetado" [digits]="0"
                                            (ngModelChange)="onChangePesoProjetadoMes(entityMes, $event)"
                                            sgtTableTrActive>
                                        </sgt-decimal2>                                         -->
                                        <input type="text"
                                            value="{{entityMes.pesoProjetado | decimalFormat: 1:0:0}}"
                                            class="form-control text-right" disabled="disabled" readonly="readonly">

                                        <div class="input-group-append" *ngIf="configAnaliseMercado?.solicitarPotencial">
                                            <span class="input-group-text">
                                                {{entityMes.pesoProjetadoPerc | decimalFormat: 1:0:0}}%
                                            </span>
                                        </div>
                                    </div>
                                </td>
                            </ng-template>

                            <td class="col-peso col-ano col-peso-realizado text-right" [class.col-separator]="!isLancamentoPeso()">
                                {{entityMes.pesoRealizado | decimalFormat: 1:0:0}}
                                <!-- <span *ngIf="isLancamentoPeso()">
                                    | {{entityMes.pesoRealizadoPercPretendido | decimalFormat: 1:0:0}}%
                                </span> -->
                            </td>
                            <td class="col-peso col-ano col-peso-pretendido-perc-evolucao col-separator text-right" *ngIf="isLancamentoPeso()">
                                {{entityMes.pesoPretendidoPercEvolucao | decimalFormat: 1:0:0}}%
                            </td>
                        </ng-template>

                        <!-- Valor-->
                        <ng-template [ngIf]="entityLancamento.controleValor">
                            <!-- Ano Anterior 2 -->
                            <td class="col-valor col-ano-anterior2 col-valor-realizado col-separator text-right">
                                {{entityMes.valorRealizadoAnoAnterior2 | decimalFormat: 1:0:0}}
                            </td>

                            <!-- Ano Anterior 1 -->
                            <td class="col-valor col-ano-anterior1 col-valor-realizado text-right">
                                {{entityMes.valorRealizadoAnoAnterior1 | decimalFormat: 1:0:0}}
                            </td>
                            <td class="col-valor col-ano-anterior1 col-valor-pretendido col-separator text-right">
                                {{entityMes.valorPretendidoAnoAnterior1 | decimalFormat: 1:0:0}}
                            </td>

                            <!-- Sell In Cliente -->
                            <td class="col-valor col-ano col-valor-potencial col-separator text-right" *ngIf="configAnaliseMercado?.solicitarPotencial && isLancamentoValor()">
                                <sgt-decimal2 [ngModel]="entityMes.valorPotencial" name="valorPotencial_{{i}}" id="valorPotencial_{{i}}"
                                    #valorPotencial="ngModel" [ngControl]="valorPotencial" [digits]="0"
                                    (ngModelChange)="onChangeValorPotencialMes(entityMes, $event)"
                                    [disabled]="!canEditLancamentoValorMensal()" [readonly]="!canEditLancamentoValorMensal()"
                                    sgtTableTrActive>
                                </sgt-decimal2>
                            </td>

                            <!-- CS RAP -->
                            <td class="col-valor col-ano col-customer-share text-right">
                                <div class="input-group">
                                    <sgt-decimal2
                                        [ngModel]="entityMes.valorPretendidoPerc"
                                        class="input-perc" name="valorPretendidoPerc_{{i}}" id="valorPretendidoPerc_{{i}}" #valorPretendidoPerc="ngModel" [ngControl]="valorPretendidoPerc" [digits]="0"
                                        (ngModelChange)="onChangeValorPretendidoPercMes(entityMes, $event)"
                                        [disabled]="!canEditLancamentoValorMensal()" [readonly]="!canEditLancamentoValorMensal()"
                                        sgtTableTrActive>
                                    </sgt-decimal2>
                                    <div class="input-group-append">
                                        <span class="input-group-text">
                                            %
                                        </span>
                                    </div>
                                    <div class="input-group-append">
                                        <span class="input-group-text">
                                            <sgt-customer-share-indicador-badge
                                                [indicador]="entityMes.indicadorCustomerSharePretendido"
                                                fontSize="8px"
                                                padding="4px"
                                                width="47px">
                                            </sgt-customer-share-indicador-badge>
                                        </span>
                                    </div>
                                </div>
                            </td>
                            <td class="col-valor col-ano col-valor-pretendido text-right">
                                <sgt-decimal2
                                    [ngModel]="entityMes.valorPretendido"
                                    name="valorPretendido_{{i}}" id="valorPretendido_{{i}}" #valorPretendido="ngModel" [ngControl]="valorPretendido" [digits]="0"
                                    (ngModelChange)="onChangeValorPretendidoMes(entityMes, $event, true)"
                                    [disabled]="!canEditLancamentoValorMensal()" [readonly]="!canEditLancamentoValorMensal()"
                                    sgtTableTrActive>
                                </sgt-decimal2>
                            </td>
                            <td class="col-valor col-ano col-valor-projetado col-separator text-right" *ngIf="showProjetado">
                                <div class="input-group">
                                    <!-- <sgt-decimal2 [ngModel]="entityMes.valorProjetado" name="valorProjetado_{{i}}" id="valorProjetado_{{i}}"
                                        #valorProjetado="ngModel" [ngControl]="valorProjetado" [digits]="0"
                                        (ngModelChange)="onChangeValorProjetadoMes(entityMes, $event)"
                                        sgtTableTrActive>
                                    </sgt-decimal2>                                       -->
                                    <input type="text"
                                        value="{{entityMes.valorProjetado | decimalFormat: 1:0:0}}"
                                        class="form-control text-right" disabled="disabled" readonly="readonly">

                                    <div class="input-group-append" *ngIf="configAnaliseMercado?.solicitarPotencial">
                                        <span class="input-group-text">
                                            | {{entityMes.valorProjetadoPerc | decimalFormat: 1:0:0}}
                                        </span>
                                    </div>
                                </div>
                            </td>

                            <!-- CS RAR -->
                            <td class="col-valor col-ano col-valor-realizado text-right">
                                {{entityMes.valorRealizado | decimalFormat: 1:0:0}}
                                <!-- <span>
                                    | {{entityMes.valorRealizadoPercPretendido | decimalFormat: 1:0:0}}%
                                </span> -->
                            </td>
                            <td class="col-valor col-ano col-valor-pretendido-perc-evolucao text-right" *ngIf="isLancamentoValor()">
                                {{entityMes.valorPretendidoPercEvolucao | decimalFormat: 1:0:0}}%
                            </td>
                        </ng-template>
                    </tr>

                    <!-- Semestre 1 -->
                    <ng-template [ngIf]="entityMes.mes === 6">
                        <tr class="semestre">
                            <td class="col-periodicidade">Semestre 1</td>

                            <!--
                            <td class="col-status col-status-pretendido text-center"></td>
                            <td class="col-status col-status-projetado text-center"></td>
                            -->

                            <!-- Quantidade -->
                            <ng-template [ngIf]="entityLancamento.controleQuantidade">
                                <td class="col-quantidade col-ano-anterior2 col-quantidade-realizada col-separator text-right">
                                    {{entityLancamento.quantidadeRealizadaSemestre1AnoAnterior2 | decimalFormat: 1:0:0}}
                                </td>
                                <td class="col-quantidade col-ano-anterior1 col-quantidade-pretendida text-right" *ngIf="isLancamentoQuantidade()">
                                    {{entityLancamento.quantidadePretendidaSemestre1AnoAnterior1 | decimalFormat: 1:0:0}}
                                </td>
                                <td class="col-quantidade col-ano-anterior1 col-quantidade-realizada col-separator text-right">
                                    {{entityLancamento.quantidadeRealizadaSemestre1AnoAnterior1 | decimalFormat: 1:0:0}}
                                </td>

                                <ng-template [ngIf]="isLancamentoQuantidade()">
                                    <td class="col-quantidade col-ano col-valor-unitario text-right" *ngIf="entityLancamento.solicitarPrecoMedio"></td>
                                    <td class="col-quantidade col-ano col-quantidade-potencial text-right" *ngIf="configAnaliseMercado?.solicitarPotencial">
                                        {{entityLancamento.quantidadePotencialSemestre1 | decimalFormat: 1:0:0}}
                                    </td>
                                    <td class="col-quantidade col-ano col-quantidade-pretendida text-right">
                                        {{entityLancamento.quantidadePretendidaSemestre1 | decimalFormat: 1:0:0}}
                                        <span *ngIf="configAnaliseMercado?.solicitarPotencial">
                                            | {{entityLancamento.quantidadePretendidaPercSemestre1 | decimalFormat: 1:0:0}}%
                                        </span>
                                    </td>
                                    <td class="col-quantidade col-ano col-valor-unitario-projetado text-right" *ngIf="showProjetado && entityLancamento.solicitarPrecoMedio"></td>
                                    <td class="col-quantidade col-ano col-quantidade-projetada text-right" *ngIf="showProjetado">
                                        {{entityLancamento.quantidadeProjetadaSemestre1 | decimalFormat: 1:0:0}}
                                        <span *ngIf="configAnaliseMercado?.solicitarPotencial">
                                            | {{entityLancamento.quantidadeProjetadaPercSemestre1 | decimalFormat: 1:0:0}}%
                                        </span>
                                    </td>
                                </ng-template>

                                <td class="col-quantidade col-ano col-quantidade-realizada text-right" [class.col-separator]="!isLancamentoQuantidade()">
                                    {{entityLancamento.quantidadeRealizadaSemestre1 | decimalFormat: 1:0:0}}
                                    <!-- <span *ngIf="isLancamentoQuantidade()">
                                        | {{entityLancamento.quantidadeRealizadaPercPretendidaSemestre1 | decimalFormat: 1:0:0}}%
                                    </span> -->
                                </td>
                                <td class="col-quantidade col-ano col-quantidade-pretendida-perc-evolucao col-separator text-right" *ngIf="isLancamentoQuantidade()">
                                    {{entityLancamento.quantidadePretendidaPercEvolucaoSemestre1 | decimalFormat: 1:0:0}}%
                                </td>
                            </ng-template>

                            <!-- Peso -->
                            <ng-template [ngIf]="entityLancamento.controlePeso">
                                <td class="col-peso col-ano-anterior2 col-peso-realizado col-separator text-right">
                                    {{entityLancamento.pesoRealizadoSemestre1AnoAnterior2 | decimalFormat: 1:0:0}}
                                </td>
                                <td class="col-peso col-ano-anterior1 col-peso-pretendido text-right" *ngIf="isLancamentoPeso()">
                                    {{entityLancamento.pesoPretendidoSemestre1AnoAnterior1 | decimalFormat: 1:0:0}}
                                </td>
                                <td class="col-peso col-ano-anterior1 col-peso-realizado col-separator text-right">
                                    {{entityLancamento.pesoRealizadoSemestre1AnoAnterior1 | decimalFormat: 1:0:0}}
                                </td>

                                <ng-template [ngIf]="isLancamentoPeso()">
                                    <td class="col-peso col-ano col-valor-unitario text-right" *ngIf="entityLancamento.solicitarPrecoMedio"></td>
                                    <td class="col-peso col-ano col-peso-potencial text-right" *ngIf="configAnaliseMercado?.solicitarPotencial">
                                        {{entityLancamento.pesoPotencialSemestre1 | decimalFormat: 1:0:0}}
                                    </td>
                                    <td class="col-peso col-ano col-peso-pretendido text-right">
                                        {{entityLancamento.pesoPretendidoSemestre1 | decimalFormat: 1:0:0}}
                                        <span *ngIf="configAnaliseMercado?.solicitarPotencial">
                                            | {{entityLancamento.pesoPretendidoPercSemestre1 | decimalFormat: 1:0:0}}%
                                        </span>
                                    </td>
                                    <td class="col-peso col-ano col-valor-unitario-projetado text-right" *ngIf="showProjetado && entityLancamento.solicitarPrecoMedio"></td>
                                    <td class="col-peso col-ano col-peso-projetado text-right" *ngIf="showProjetado">
                                        {{entityLancamento.pesoProjetadoSemestre1 | decimalFormat: 1:0:0}}
                                        <span *ngIf="configAnaliseMercado?.solicitarPotencial">
                                            | {{entityLancamento.pesoProjetadoPercSemestre1 | decimalFormat: 1:0:0}}%
                                        </span>
                                    </td>
                                </ng-template>

                                <td class="col-peso col-ano col-peso-realizado text-right" [class.col-separator]="!isLancamentoPeso()">
                                    {{entityLancamento.pesoRealizadoSemestre1 | decimalFormat: 1:0:0}}
                                    <!-- <span *ngIf="isLancamentoPeso()">
                                        | {{entityLancamento.pesoRealizadoPercPretendidoSemestre1 | decimalFormat: 1:0:0}}%
                                    </span> -->
                                </td>
                                <td class="col-peso col-ano col-peso-pretendido-perc-evolucao col-separator text-right" *ngIf="isLancamentoPeso()">
                                    {{entityLancamento.pesoPretendidoPercEvolucaoSemestre1 | decimalFormat: 1:0:0}}%
                                </td>
                            </ng-template>

                            <!-- Valor -->
                            <ng-template [ngIf]="entityLancamento.controleValor">
                                <!-- Ano Anterior 2 -->
                                <td class="col-valor col-ano-anterior2 col-valor-realizado col-separator text-right">
                                    {{entityLancamento.valorRealizadoSemestre1AnoAnterior2 | decimalFormat: 1:0:0}}
                                </td>

                                <!-- Ano Anterior 1 -->
                                <td class="col-valor col-ano-anterior1 col-valor-realizado text-right">
                                    {{entityLancamento.valorRealizadoSemestre1AnoAnterior1 | decimalFormat: 1:0:0}}
                                </td>
                                <td class="col-valor col-ano-anterior1 col-valor-pretendido col-separator text-right">
                                    {{entityLancamento.valorPretendidoSemestre1AnoAnterior1 | decimalFormat: 1:0:0}}
                                </td>

                                <!-- Sell In Cliente -->
                                <td class="col-valor col-ano col-valor-potencial col-separator text-right" *ngIf="configAnaliseMercado?.solicitarPotencial && isLancamentoValor()">
                                    {{entityLancamento.valorPotencialSemestre1 | decimalFormat: 1:0:0}}
                                </td>

                                <!-- CS RAP -->
                                <td class="col-valor col-ano col-customer-share text-right">
                                    <sgt-customer-share-indicador-badge
                                        [indicador]="entityLancamento.indicadorCustomerSharePretendidoSemestre1"
                                        [perc]="entityLancamento.valorPretendidoPercSemestre1"
                                        fontSize="8px"
                                        padding="4px">
                                    </sgt-customer-share-indicador-badge>
                                </td>
                                <td class="col-valor col-ano col-valor-pretendido text-right">
                                    {{entityLancamento.valorPretendidoSemestre1 | decimalFormat: 1:0:0}}
                                </td>
                                <td class="col-valor col-ano col-valor-projetado col-separator text-right" *ngIf="showProjetado">
                                    {{entityLancamento.valorProjetadoSemestre1 | decimalFormat: 1:0:0}}
                                    <span *ngIf="configAnaliseMercado?.solicitarPotencial">
                                        | {{entityLancamento.valorProjetadoPercSemestre1 | decimalFormat: 1:0:0}}%
                                    </span>
                                </td>

                                <!-- CS RAR -->
                                <td class="col-valor col-ano col-valor-realizado text-right">
                                    {{entityLancamento.valorRealizadoSemestre1 | decimalFormat: 1:0:0}}
                                    <!-- <span>
                                        | {{entityLancamento.valorRealizadoPercPretendidoSemestre1 | decimalFormat: 1:0:0}}%
                                    </span> -->
                                </td>
                                <td class="col-valor col-ano col-valor-pretendido-perc-evolucao text-right" *ngIf="isLancamentoValor()">
                                    {{entityLancamento.valorPretendidoPercEvolucaoSemestre1 | decimalFormat: 1:0:0}}%
                                </td>
                            </ng-template>
                        </tr>
                        <tr class="semestre-divider">
                            <td colspan="24"></td>
                        </tr>
                    </ng-template>

                    <!-- Semestre 2 -->
                    <ng-template [ngIf]="entityMes.mes === 12">
                        <tr class="semestre">
                            <td class="col-periodicidade">Semestre 2</td>

                            <!--
                            <td class="col-status col-status-pretendido text-center"></td>
                            <td class="col-status col-status-projetado text-center"></td>
                            -->

                            <!-- Quantidade -->
                            <ng-template [ngIf]="entityLancamento.controleQuantidade">
                                <td class="col-quantidade col-ano-anterior2 col-quantidade-realizada col-separator text-right">
                                    {{entityLancamento.quantidadeRealizadaSemestre2AnoAnterior2 | decimalFormat: 1:0:0}}
                                </td>
                                <td class="col-quantidade col-ano-anterior1 col-quantidade-pretendida text-right" *ngIf="isLancamentoQuantidade()">
                                    {{entityLancamento.quantidadePretendidaSemestre2AnoAnterior1 | decimalFormat: 1:0:0}}
                                </td>
                                <td class="col-quantidade col-ano-anterior1 col-quantidade-realizada col-separator text-right">
                                    {{entityLancamento.quantidadeRealizadaSemestre2AnoAnterior1 | decimalFormat: 1:0:0}}
                                </td>

                                <ng-template [ngIf]="isLancamentoQuantidade()">
                                    <td class="col-quantidade col-ano col-valor-unitario text-right" *ngIf="entityLancamento.solicitarPrecoMedio"></td>
                                    <td class="col-quantidade col-ano col-quantidade-potencial text-right" *ngIf="configAnaliseMercado?.solicitarPotencial">
                                        {{entityLancamento.quantidadePotencialSemestre2 | decimalFormat: 1:0:0}}
                                    </td>
                                    <td class="col-quantidade col-ano col-quantidade-pretendida text-right">
                                        {{entityLancamento.quantidadePretendidaSemestre2 | decimalFormat: 1:0:0}}
                                        <span *ngIf="configAnaliseMercado?.solicitarPotencial">
                                            | {{entityLancamento.quantidadePretendidaPercSemestre2 | decimalFormat: 1:0:0}}%
                                        </span>
                                    </td>
                                    <td class="col-quantidade col-ano col-valor-unitario-projetado text-right" *ngIf="showProjetado && entityLancamento.solicitarPrecoMedio"></td>
                                    <td class="col-quantidade col-ano col-quantidade-projetada text-right" *ngIf="showProjetado">
                                        {{entityLancamento.quantidadeProjetadaSemestre2 | decimalFormat: 1:0:0}}
                                        <span *ngIf="configAnaliseMercado?.solicitarPotencial">
                                            | {{entityLancamento.quantidadeProjetadaPercSemestre2 | decimalFormat: 1:0:0}}%
                                        </span>
                                    </td>
                                </ng-template>

                                <td class="col-quantidade col-ano col-quantidade-realizada text-right" [class.col-separator]="!isLancamentoQuantidade()">
                                    {{entityLancamento.quantidadeRealizadaSemestre2 | decimalFormat: 1:0:0}}
                                    <!-- <span *ngIf="isLancamentoQuantidade()">
                                        | {{entityLancamento.quantidadeRealizadaPercPretendidaSemestre2 | decimalFormat: 1:0:0}}%
                                    </span> -->
                                </td>
                                <td class="col-quantidade col-ano col-quantidade-pretendida-perc-evolucao col-separator text-right" *ngIf="isLancamentoQuantidade()">
                                    {{entityLancamento.quantidadePretendidaPercEvolucaoSemestre2 | decimalFormat: 1:0:0}}%
                                </td>
                            </ng-template>

                            <!-- Peso -->
                            <ng-template [ngIf]="entityLancamento.controlePeso">
                                <td class="col-peso col-ano-anterior2 col-peso-realizado col-separator text-right">
                                    {{entityLancamento.pesoRealizadoSemestre2AnoAnterior2 | decimalFormat: 1:0:0}}
                                </td>
                                <td class="col-peso col-ano-anterior1 col-peso-pretendido text-right" *ngIf="isLancamentoPeso()">
                                    {{entityLancamento.pesoPretendidoSemestre2AnoAnterior1 | decimalFormat: 1:0:0}}
                                </td>
                                <td class="col-peso col-ano-anterior1 col-peso-realizado col-separator text-right">
                                    {{entityLancamento.pesoRealizadoSemestre2AnoAnterior1 | decimalFormat: 1:0:0}}
                                </td>

                                <ng-template [ngIf]="isLancamentoPeso()">
                                    <td class="col-peso col-ano col-valor-unitario text-right" *ngIf="entityLancamento.solicitarPrecoMedio"></td>
                                    <td class="col-peso col-ano col-peso-potencial text-right" *ngIf="configAnaliseMercado?.solicitarPotencial">
                                        {{entityLancamento.pesoPotencialSemestre2 | decimalFormat: 1:0:0}}
                                    </td>
                                    <td class="col-peso col-ano col-peso-pretendido text-right">
                                        {{entityLancamento.pesoPretendidoSemestre2 | decimalFormat: 1:0:0}}
                                        <span *ngIf="configAnaliseMercado?.solicitarPotencial">
                                            | {{entityLancamento.pesoPretendidoPercSemestre2 | decimalFormat: 1:0:0}}%
                                        </span>
                                    </td>
                                    <td class="col-peso col-ano col-valor-unitario-projetado text-right" *ngIf="showProjetado && entityLancamento.solicitarPrecoMedio"></td>
                                    <td class="col-peso col-ano col-peso-projetado text-right" *ngIf="showProjetado">
                                        {{entityLancamento.pesoProjetadoSemestre2 | decimalFormat: 1:0:0}}
                                        <span *ngIf="configAnaliseMercado?.solicitarPotencial">
                                            | {{entityLancamento.pesoProjetadoPercSemestre2 | decimalFormat: 1:0:0}}%
                                        </span>
                                    </td>
                                </ng-template>

                                <td class="col-peso col-ano col-peso-realizado text-right" [class.col-separator]="!isLancamentoPeso()">
                                    {{entityLancamento.pesoRealizadoSemestre2 | decimalFormat: 1:0:0}}
                                    <!-- <span *ngIf="isLancamentoPeso()">
                                        | {{entityLancamento.pesoRealizadoPercPretendidoSemestre2 | decimalFormat: 1:0:0}}%
                                    </span> -->
                                </td>
                                <td class="col-peso col-ano col-peso-pretendido-perc-evolucao col-separator text-right" *ngIf="isLancamentoPeso()">
                                    {{entityLancamento.pesoPretendidoPercEvolucaoSemestre2 | decimalFormat: 1:0:0}}%
                                </td>
                            </ng-template>

                            <!-- Valor -->
                            <ng-template [ngIf]="entityLancamento.controleValor">
                                <!-- Ano Anterior 2 -->
                                <td class="col-valor col-ano-anterior2 col-valor-realizado col-separator text-right">
                                    {{entityLancamento.valorRealizadoSemestre2AnoAnterior2 | decimalFormat: 1:0:0}}
                                </td>

                                <!-- Ano Anterior 1 -->
                                <td class="col-valor col-ano-anterior1 col-valor-realizado text-right">
                                    {{entityLancamento.valorRealizadoSemestre2AnoAnterior1 | decimalFormat: 1:0:0}}
                                </td>
                                <td class="col-valor col-ano-anterior1 col-valor-pretendido col-separator text-right">
                                    {{entityLancamento.valorPretendidoSemestre2AnoAnterior1 | decimalFormat: 1:0:0}}
                                </td>

                                <!-- Sell In Cliente -->
                                <td class="col-valor col-ano col-valor-potencial col-separator text-right" *ngIf="configAnaliseMercado?.solicitarPotencial && isLancamentoValor()">
                                    {{entityLancamento.valorPotencialSemestre2 | decimalFormat: 1:0:0}}
                                </td>

                                <!-- CS RAP -->
                                <td class="col-valor col-ano col-customer-share text-right">
                                    <sgt-customer-share-indicador-badge
                                        [indicador]="entityLancamento.indicadorCustomerSharePretendidoSemestre2"
                                        [perc]="entityLancamento.valorPretendidoPercSemestre2"
                                        fontSize="8px"
                                        padding="4px">
                                    </sgt-customer-share-indicador-badge>
                                </td>
                                <td class="col-valor col-ano col-valor-pretendido text-right">
                                    {{entityLancamento.valorPretendidoSemestre2 | decimalFormat: 1:0:0}}
                                </td>
                                <td class="col-valor col-ano col-valor-projetado col-separator text-right" *ngIf="showProjetado">
                                    {{entityLancamento.valorProjetadoSemestre2 | decimalFormat: 1:0:0}}
                                    <span *ngIf="configAnaliseMercado?.solicitarPotencial">
                                        | {{entityLancamento.valorProjetadoPercSemestre2 | decimalFormat: 1:0:0}}%
                                    </span>
                                </td>

                                <!-- CS RAR -->
                                <td class="col-valor col-ano col-valor-realizado text-right">
                                    {{entityLancamento.valorRealizadoSemestre2 | decimalFormat: 1:0:0}}
                                    <!-- <span>
                                        | {{entityLancamento.valorRealizadoPercPretendidoSemestre2 | decimalFormat: 1:0:0}}%
                                    </span> -->
                                </td>
                                <td class="col-valor col-ano col-valor-pretendido-perc-evolucao text-right" *ngIf="isLancamentoValor()">
                                    {{entityLancamento.valorPretendidoPercEvolucaoSemestre2 | decimalFormat: 1:0:0}}%
                                </td>
                            </ng-template>
                        </tr>
                    </ng-template>
                </ng-template>
            </tbody>
        </table>

        <div class="row">
            <div class="form-group col-12">
                <label for="codigo" class="col-form-label">Anotação</label>
                <textarea class="form-control" [(ngModel)]="entityLancamento.anotacao" #anotacao="ngModel" name="anotacao" id="anotacao" rows="1" sgtAutosize
                    placeholder="Anotação sobre seu lançamento"
                    [required]="isAnotacaoRequiredSemQuantidadePretendida() || isAnotacaoRequiredSemPesoPretendido() || isAnotacaoRequiredSemValorPretendido()"
                    [minlength]="(isAnotacaoRequiredSemQuantidadePretendida() || isAnotacaoRequiredSemPesoPretendido() || isAnotacaoRequiredSemValorPretendido()) ? 15 : 0"
                    [disabled]="!canEdit" [readOnly]="!canEdit">
                </textarea>
                <sgt-form-control-error
                    *ngIf="anotacao.errors && anotacao.errors.required && anotacao.dirty"
                    msgError="A anotação é obrigatória">
                </sgt-form-control-error>
                <sgt-form-control-error
                    *ngIf="anotacao.errors && anotacao.errors.minlength"
                    msgError="A anotação deve ter no mínimo 15 caracteres">
                </sgt-form-control-error>
            </div>
        </div>
    </ng-template>
</form>
